import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2023/Lic/C";

export const licitaciones2023 = [
    {
        // CONVOCATORIA NUM# 045
            'numConvocatoria' : 'Convocatoria No. 045/2023.',
            'idConvocatoria' : 'Convocatoria45',
            'procedimientos' : [
        // Licitación N489
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N489-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Ampliación de la red de agua potable e interconexión a la red de CFE de paneles solares en la localidad de Cuesta Colorada en el municipio de Ixmiquilpan; ubicada en la localidad de Cuesta Colorada, Municipio Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }45/N489/N489.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }45/N489/JAN489.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }45/N489/APN489.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }45/N489/FAN489.pdf`,
                       },
                    ],
                },
        // Licitación N488
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N488-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de empedrado ahogado de camino San Isidro a colonia Guadalupe El Astillero; en el municipio de Nopala de Villagrán; ubicada en la localidad de San Isidro, Municipio de Nopala de Villagrán, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }45/N488/N488.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }45/N488/JAN488.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }45/N488/APN488.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }45/N488/FAN488.pdf`,
                       },
                    ],
                },
        // Licitación N487
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N487-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de calle principal en la colonia Real Toledo; municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }45/N487/N487.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }45/N487/JAN487.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }45/N487/APN487.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }45/N487/FAN487.pdf`,
                    //    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 044
            'numConvocatoria' : 'Convocatoria No. 044/2023.',
            'idConvocatoria' : 'Convocatoria44',
            'procedimientos' : [
        // Licitación N486
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N486-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la remodelación de la Plaza Independencia, en el municipio de Pachuca; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }44/N486/N486.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N486/JAN486.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N486/APN486.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N486/FAN486.pdf`,
                       },
                    ],
                },
        // Licitación N485
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N485-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la construcción de oficinas de Secretaría de Movilidad y Transporte; ubicado en la localidad de Jagüey de Téllez (Estación Téllez), Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }44/N485/N485.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N485/JAN485.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N485/APN485.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N485/FAN485.pdf`,
                       },
                    ],
                },
        // Licitación N484
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N484-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de la avenida Diesel Nacional; en el municipio de Tepeapulco; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }44/N484/N484.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N484/JAN484.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N484/APN484.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N484/FAN484.pdf`,
                       },
                    ],
                },
        // Licitación N483
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N483-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Los Fresnos; en el municipio de Atotonilco el Grande; ubicada en la localidad de La Puebla, Municipio de Atotonilco el Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }44/N483/N483.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N483/JAN483.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N483/APN483.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N483/FAN483.pdf`,
                       },
                    ],
                },
        // Licitación N482
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N482-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle la Piaña, Santa María Amajac; en el municipio de Atotonilco el Grande; ubicada en la localidad de Santa María Amajac, Municipio de Atotonilco el Grande, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }44/N482/N482.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }44/N482/JAN482.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }44/N482/APN482.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }44/N482/FAN482.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 043
            'numConvocatoria' : 'Convocatoria No. 043/2023.',
            'idConvocatoria' : 'Convocatoria43',
            'procedimientos' : [
        // Licitación N481
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N481-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Construcción de muros de contención en la comunidad de Tecolotitla; en el municipio de Atlapexco; ubicada en la localidad de Tecolotitla, Municipio de Atlapexco, Estado de Hidalgo. Segundo procedimiento. ',
                    'urlAnexos' : `${ ligabase }43/N481/N481.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N481/JAN481.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N481/APN481.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N481/FAN481.pdf`,
                       },
                    ],
                },
        // Licitación N480
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N480-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en la calle de acceso principal a la localidad de La Ilusión - Anacleto Ramos - Potrero Zactipan - Octatitla; en el municipio de Jaltocán; ubicada en la localidad de La Ilusión, Municipio de Jaltocán, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }43/N480/N480.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N480/JAN480.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N480/APN480.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N480/FAN480.pdf`,
                       },
                    ],
                },
        // Licitación N479
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N479-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de retorno en vialidad, Hospital General de Pachuca; en el municipio de San Agustín Tlaxiaca, ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }43/N479/N479.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N479/JAN479.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N479/APN479.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N479/FAN479.pdf`,
                       },
                    ],
                },
        // Licitación N478
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N478-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Empedrado ahogado en libramiento Bojhay a centro de Pañhé, en el municipio de Tecozautla, ubicada en la localidad de Pañhé, Municipio de Tecozautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }43/N478/N478.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N478/JAN478.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N478/APN478.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N478/FAN478.pdf`,
                       },
                    ],
                },
        // Licitación N477
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N477-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica de C.E Huautla - Tamoyon I, Municipio de Huautla, ubicada en la localidad de Tamoyón l, Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }43/N477/N477.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N477/JAN477.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N477/APN477.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N477/FAN477.pdf`,
                       },
                    ],
                },
        // Licitación N476
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N476-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de la Carretera Estatal paso por Tulancingo, ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }43/N476/N476.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N476/JAN476.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N476/APN476.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N476/FAN476.pdf`,
                       },
                    ],
                },
        // Licitación N475
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N475-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de acceso principal Tepatepec-San Juan Tepa; municipio de Francisco I. Madero, ubicada en la localidad de San Juan Tepa, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }43/N475/N475.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }43/N475/JAN475.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }43/N475/APN475.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }43/N475/FAN475.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 042
            'numConvocatoria' : 'Convocatoria No. 042/2023.',
            'idConvocatoria' : 'Convocatoria42',
            'procedimientos' : [
        // Licitación N474
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N474-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Rehabilitación en azoteas, fachadas y anexo del CRIH, Sede de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }42/N474/N474.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N474/JAN474.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N474/APN474.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N474/FAN474.pdf`,
                       },
                    ],
                },
        // Licitación N473
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N473-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de nueva celda para disposición de residuos sólidos, para el municipio de Chilcuautla; ubicada en la localidad de El Deca, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }42/N473/N473.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N473/JAN473.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N473/APN473.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N473/FAN473.pdf`,
                       },
                    ],
                },
        // Licitación N472
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N472-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Arco de Bienvenida Tenango de Doria; ubicada en la localidad El Damo, Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }42/N472/N472.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N472/JAN472.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N472/APN472.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N472/FAN472.pdf`,
                       },
                    ],
                },
        // Licitación N471
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N471-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle 20 de Noviembre, en la localidad de Bangandhó, municipio de Ixmiquilpan; ubicada en la localidad de Bangandhó, Municipio de Ixmiquilpan, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }42/N471/N471.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N471/JAN471.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N471/APN471.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N471/FAN471.pdf`,
                       },
                    ],
                },
        // Licitación N470
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N470-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación asfáltica de la Av. Nicolas Bravo, Bo. Casa Grande en San Agustín Tlaxiaca; ubicada en la localidad de Casa Grande (Barrio), Municipio de San Agustín Tlaxiaca, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }42/N470/N470.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N470/JAN470.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N470/APN470.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N470/FAN470.pdf`,
                       },
                    ],
                },
        // Licitación N469
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N469-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en la antigua carretera a Santa Elena Paliseca ubicada en la Localidad de Santa Elena Paliseca, municipio de Cuautepec de Hinojosa; ubicada en la localidad de Santa Elena Paliseca, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo. Segundo procedimiento',
                    'urlAnexos' : `${ ligabase }42/N469/N469.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N469/JAN469.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N469/APN469.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N469/FAN469.pdf`,
                       },
                    ],
                },
        // Licitación N468
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N468-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Modernización de camino Santa Ana-La Loma López Rayón y calle Cobre en Ixmiquilpan; ubicada en la localidad de Santa Ana (Barrio de Progreso), Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }42/N468/N468.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }42/N468/JAN468.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }42/N468/APN468.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }42/N468/FAN468.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 041
            'numConvocatoria' : 'Convocatoria No. 041/2023.',
            'idConvocatoria' : 'Convocatoria41',
            'procedimientos' : [
        // Licitación N467
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N467-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Álamos, en el municipio de Tepeapulco; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo. Segundo procedimiento',
                    'urlAnexos' : `${ ligabase }41/N467/N467.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N467/JAN467.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N467/APN467.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N467/FAN467.pdf`,
                       },
                    ],
                },
        // Licitación N466
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N466-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en el acceso a Huitzila, tramo: E.C. Carr. México - Pachuca a la calle Campeche; en el municipio de Tizayuca; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }41/N466/N466.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N466/JAN466.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N466/APN466.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N466/FAN466.pdf`,
                       },
                    ],
                },
        // Licitación N465
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N465-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación del camino Acayuca E.C. (Otongo - Tepehuacán de Guerrero), en el municipio de Molango; ubicada en la localidad de Acayuca, Municipio de Molango, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }41/N465/N465.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N465/JAN465.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N465/APN465.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N465/FAN465.pdf`,
                       },
                    ],
                },
        // Licitación N464
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N464-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en El Arenal, en la localidad de San José Tepenene Manzana No.1 calle Emiliano Zapata; ubicada en la localidad de Ojo de Agua San José Tepenene, Municipio de Emiliano Zapata, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }41/N464/N464.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N464/JAN464.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N464/APN464.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }41/N464/FAN464.pdf`,
                    //    },
                    ],
                },
        // Licitación N463
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N463-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle Niños Héroes en la localidad El Mothé en el municipio de San Salvador; ubicada en la localidad de El Mothé, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }41/N463/N463.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N463/JAN463.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N463/APN463.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N463/FAN463.pdf`,
                       },
                    ],
                },
        // Licitación N462
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N462-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación y construcción de drenaje sanitario de Avenida Principal en colonia Ampliación El Palmar; municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }41/N462/N462.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N462/JAN462.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N462/APN462.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N462/FAN462.pdf`,
                       },
                    ],
                },
        // Licitación N461
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N461-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de centro comunitario de la localidad La Estación, municipio de Ixmiquilpan, Hidalgo; en la localidad de La Estación, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }41/N461/N461.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }41/N461/JAN461.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }41/N461/APN461.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }41/N461/FAN461.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 040
            'numConvocatoria' : 'Convocatoria No. 040/2023.',
            'idConvocatoria' : 'Convocatoria40',
            'procedimientos' : [
        // Licitación N460
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N460-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Mejoramiento Estacionamiento PGJEH; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N460/N460.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N460/JAN460.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N460/APN460.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N460/FAN460.pdf`,
                       },
                    ],
                },
        // Licitación N459
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N459-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontológico Integral de Pachuca se Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N459/N459.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N459/JAN459.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N459/APN459.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N459/FAN459.pdf`,
                       },
                    ],
                },
        // Licitación N458
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N458-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación asfáltica de circuito poniente del Fraccionamiento Guzmán Mayer, en el municipio de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N458/N458.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N458/JAN458.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N458/APN458.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N458/FAN458.pdf`,
                       },
                    ],
                },
        // Licitación N457
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N457-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de Calzada Veracruz a San Bartolo, en la localidad de San Bartolo; en el municipio de Pachuca de Soto; ubicada en la localidad de Ejido San Bartolo, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N457/N457.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N457/JAN457.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N457/APN457.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N457/FAN457.pdf`,
                       },
                    ],
                },
        // Licitación N456
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N456-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en la localidad del Huaxtho en el municipio de Actopan; ubicada en la localidad de El Huaxtho, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N456/N456.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N456/JAN456.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N456/APN456.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N456/FAN456.pdf`,
                       },
                    ],
                },
        // Licitación N455
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N455-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Modernización del C.R. El Ixtle – Los Cerezos; en el municipio de Huahutla; ubicada en la localidad de El Ixtle, Municipio de Huahutla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N455/N455.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N455/JAN455.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N455/APN455.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N455/FAN455.pdf`,
                       },
                    ],
                },
        // Licitación N454
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N454-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 12 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico del acceso a la comunidad de Palmitas;en el municipio de La Misión; ubicada en la localidad de Las Palmitas, Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N454/N454.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N454/JAN454.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N454/APN454.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N454/FAN454.pdf`,
                       },
                    ],
                },
        // Licitación N453
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N453-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontológico Integral de Tlahuelilpan; ubicado en la localidad y Municipio de Tlahuelilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N453/N453.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N453/JAN453.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N453/APN453.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N453/FAN453.pdf`,
                       },
                    ],
                },
        // Licitación N452
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N452-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontologico de Acaxochitlán 2da etapa; ubicado en la localidad y Municipio de Acaxochitlán, Estado de Hidalgo',
                    'urlAnexos' : `${ ligabase }40/N452/N452.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N452/JAN452.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N452/APN452.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N452/FAN452.pdf`,
                       },
                    ],
                },
        // Licitación N451
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N451-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de puente vehicular Cuamontax; municipio de Huazalingo; ubicada en la localidad de Cuamontax, Municipio de Huazalingo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N451/N451.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N451/JAN451.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N451/APN451.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N451/FAN451.pdf`,
                       },
                    ],
                },
        // Licitación N450
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N450-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Remodelación Unidad Deportiva San Bartolo; en el municipio de San Bartolo Tutotepec.; ubicada en la localidad y Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N450/N450.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N450/JAN450.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N450/APN450.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N450/FAN450.pdf`,
                       },
                    ],
                },
        // Licitación N449
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N449-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle de la localidad La Gargantilla; en el municipio de Pisaflores; ubicada en la localidad de Gargantilla, Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }40/N449/N449.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }40/N449/JAN449.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }40/N449/APN449.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }40/N449/FAN449.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 039
            'numConvocatoria' : 'Convocatoria No. 039/2023.',
            'idConvocatoria' : 'Convocatoria39',
            'procedimientos' : [
        // Licitación N448
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N448-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Reconstrucción del Boulevard de Acceso a Villa de Tezontepec (tramo Platah - Av- Juárez); en el municipio de Villa de Tezontepec; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N448/N448.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N448/JAN448.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N448/APN448.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N448/FAN448.pdf`,
                       },
                    ],
                },
        // Licitación N447
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N447-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción y reconstrucción de pavimento asfáltico en Blvd. Santa Rita del Km. 0+000 al Km. 0+650, La Calera, municipio de Mineral dela Reforma; ubicada en la localidad de Santa María la Calera, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N447/N447.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N447/JAN447.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N447/APN447.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N447/FAN447.pdf`,
                       },
                    ],
                },
        // Licitación N446
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N446-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento hidráulico en calle Línea divisoria en San Pedro Huaquilpan; en el municipio de Zapotlán; ubicada en la localidad de San Pedro Huaquilpan, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N446/N446.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N446/JAN446.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N446/APN446.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N446/FAN446.pdf`,
                       },
                    ],
                },
        // Licitación N445
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N445-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 11 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Modernización del camino Ohuatipa - Texoloc, tramo: del Km. 4+760 al Km. 5+760; en el municipio de Xochiatipan; ubicada en la localidad de Ohuatipa, Municipio de Xochiatipan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N445/N445.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N445/JAN445.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N445/APN445.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N445/FAN445.pdf`,
                       },
                    ],
                },
        // Licitación N444
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N444-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en calle Almada, barrio El Barroso en la localidad de colonia El Rosario; ubicada en la localidad de El Rosario [Colonia], Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N444/N444.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N444/JAN444.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N444/APN444.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N444/FAN444.pdf`,
                       },
                    ],
                },
        // Licitación N443
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N443-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en municipio de San Salvador, localidad Francisco Villa camino El Canal Norte; ubicada en la localidad de Francisco Villa, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N443/N443.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N443/JAN443.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N443/APN443.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }39/N443/FAN443.pdf`,
                    //    },
                    ],
                },
        // Licitación N442
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N442-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en Las Palmas; en el municipio de Acatlán; ubicada en la localidad y Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N442/N442.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N442/JAN442.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N442/APN442.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N442/FAN442.pdf`,
                       },
                    ],
                },
        // Licitación N441
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N441-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Estudio de geotecnia para determinar la capacidad de carga del suelo de la reserva territorial Zapotlán; en el municipio de Zapotlán de Juárez; ubicada en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N441/N441.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N441/JAN441.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N441/APN441.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N441/FAN441.pdf`,
                       },
                    ],
                },
        // Licitación N440
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N440-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de unidad deportiva Tenango de Doria; en el municipio de Tenango de Doria; ubicada en la localidad y Municipio de Tenango de Doria, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N440/N440.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N440/JAN440.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N440/APN440.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N440/FAN440.pdf`,
                       },
                    ],
                },
        // Licitación N439
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N439-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de la C.E. Saucillo - Nopala; en el municipio de Huichapan; ubicada en la localidad y Municipio de Huichapan, Estado de Hidalgo',
                    'urlAnexos' : `${ ligabase }39/N439/N439.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N439/JAN439.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N439/APN439.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N439/FAN439.pdf`,
                       },
                    ],
                },
        // Licitación N438
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N438-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Estudio y proyecto para la construcción del nuevo edificio de Oficinas Gubernamentales; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N438/N438.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N438/JAN438.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N438/APN438.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N438/FAN438.pdf`,
                       },
                    ],
                },
        // Licitación N437
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N437-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica, interconexión Los Pinos Panales – El Maye; en el municipio de Ixmiquilpan; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N437/N437.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N437/JAN437.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N437/APN437.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N437/FAN437.pdf`,
                       },
                    ],
                },
        // Licitación N436
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N436-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento en el boulevard Nuevo Hidalgo, tramo Distribuidor Colonias - Distribuidor Vial Municipios Unidos - puente El Venado (cuerpo izquierdo); ubicada en localidades varias, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N436/N436.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N436/JAN436.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N436/APN436.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N436/FAN436.pdf`,
                       },
                    ],
                },
        // Licitación N435
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N435-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de techado en el mercado Morelos, en el Municipio de Zimapán; ubicada en la localidad y Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N435/N435.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N435/JAN435.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N435/APN435.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N435/FAN435.pdf`,
                       },
                    ],
                },
        // Licitación N434
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N434-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en avenida San Marco del km. 0+000 al km. 0+420 en la colonia Rinconadas de San Francisco, municipio de Mineral de la Reforma; ubicada en la localidad de Rinconadas de San Francisco el Venado, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N434/N434.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N434/JAN434.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N434/APN434.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N434/FAN434.pdf`,
                       },
                    ],
                },
        // Licitación N433
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N433-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Perforación de pozo profundo para extracción de agua potable, en la localidad de los Filtros, municipio de Francisco I. Madero; ubicada en la localidad de Los Filtros, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N433/N433.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N433/JAN433.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N433/APN433.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }39/N433/FAN433.pdf`,
                    //    },
                    ],
                },
        // Licitación N432
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N432-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en la localidad de La Peña en el municipio de Actopan; ubicada en la localidad de La Peña, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N432/N432.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N432/JAN432.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N432/APN432.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N432/FAN432.pdf`,
                       },
                    ],
                },
        // Licitación N431
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N431-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 4 al 8 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica calle Río Hondo de la Manzana Uno en la localidad de Chicavasco en el municipio de Actopan; ubicada en la localidad de Chicavasco, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }39/N431/N431.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }39/N431/JAN431.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }39/N431/APN431.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }39/N431/FAN431.pdf`,
                       },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 038
            'numConvocatoria' : 'Convocatoria No. 038/2023.',
            'idConvocatoria' : 'Convocatoria38',
            'procedimientos' : [
        // Licitación N430
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N430-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Señalamiento horizontal y vertical en avenida de acceso.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo. Segundo procedimiento',
                    'urlAnexos' : `${ ligabase }38/N430/N430.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N430/JAN430.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N430/APN430.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }38/N430/FAN430.pdf`,
                    //    },
                    ],
                },
        // Licitación N429
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N429-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de la Planta de Tratamiento zona norte para beneficiar a la localidad de Acatepec en el Municipio de Huautla; ubicada en la localidad de Acatepec, Municipio de Huautla, Estado de Hidalgo. Segundo procedimiento',
                    'urlAnexos' : `${ ligabase }38/N429/N429.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N429/JAN429.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N429/APN429.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N429/FAN429.pdf`,
                       },
                    ],
                },
        // Licitación N428
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N428-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de alcantarillado sanitario y Planta de tratamiento de aguas residuales Centro en Caltimacán, municipio de Tasquillo; ubicada en la localidad de Caltimacán, Municipio de Tasquillo, Estado de Hidalgo. Tercer procedimiento.',
                    'urlAnexos' : `${ ligabase }38/N428/N428.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }38/N428/JAN428.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }38/N428/APN428.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }38/N428/FAN428.pdf`,
                       },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 037
            'numConvocatoria' : 'Convocatoria No. 037/2023.',
            'idConvocatoria' : 'Convocatoria37',
            'procedimientos' : [
        // Licitación N427
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N427-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en San Bartolo (El LIano); en el municipio de Acatlán; ubicada en la localidad y Municipio de Acatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N427/N427.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N427/JAN427.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N427/APN427.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N427/FAN427.pdf`,
                       },
                    ],
                },
        // Licitación N426
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N426-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de calle asfáltica Tlanalapa - Chinconcuac; en el municipio de Tlanalapa; ubicada en varias localidades del Municipio de Tlanalapa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N426/N426.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N426/JAN426.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N426/APN426.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N426/FAN426.pdf`,
                       },
                    ],
                },
        // Licitación N425
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N425-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Ampliación de Drenaje Sanitario Villa Mil - La Alcantarilla, en la localidad de Tlamaco; en el municipio de Atitalaquia; ubicada en la localidad de Tlamaco (San Gerónimo Tlamaco), Municipio de Atitalaquia, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N425/N425.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N425/JAN425.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N425/APN425.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N425/FAN425.pdf`,
                       },
                    ],
                },
        // Licitación N424
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N424-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Boulevard Minero (crucero semaforizado para acceso a Centro de Justicia); en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N424/N424.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N424/JAN424.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N424/APN424.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N424/FAN424.pdf`,
                       },
                    ],
                },
        // Licitación N423
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N423-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calle El Bhenu en la localidad de El Alberto, municipio de Ixmiquilpan, Hidalgo; ubicada en la localidad de El Alberto, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N423/N423.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N423/JAN423.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N423/APN423.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N423/FAN423.pdf`,
                       },
                    ],
                },
        // Licitación N422
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N422-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 6 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica del Camino Cruztitla; municipio de Huejutla de Reyes; ubicada en la localidad de Cruztitla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N422/N422.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N422/JAN422.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N422/APN422.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N422/FAN422.pdf`,
                       },
                    ],
                },
        // Licitación N421
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N421-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de vialidad en calle Cuauhtémoc, en la colonia Centro, en el municipio de Tolcayuca, Hidalgo; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N421/N421.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N421/JAN421.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N421/APN421.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N421/FAN421.pdf`,
                       },
                    ],
                },
        // Licitación N420
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N420-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de calle Escuadra con Cuesta Chica, colonia La Campesina, en el municipio de Zacualtipán de Ángeles; ubicada en la localidad y Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N420/N420.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N420/JAN420.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N420/APN420.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N420/FAN420.pdf`,
                       },
                    ],
                },
        // Licitación N419
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N419-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera ramal a Tlahuelompa, en el municipio de Zacualtipán; ubicada en la localidad de La Tlahuelompa (San Francisco Tlahuelompa), Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N419/N419.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N419/JAN419.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N419/APN419.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N419/FAN419.pdf`,
                       },
                    ],
                },
        // Licitación N418
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N418-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación del Circuito Av. Cuitláhuac y Av. Vicente Guerrero en la primera, sexta y séptima demarcación; en el municipio de Mixquiahuala de Juárez; ubicada en la localidad y Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N418/N418.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N418/JAN418.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N418/APN418.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N418/FAN418.pdf`,
                       },
                    ],
                },
        // Licitación N417
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N417-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Red de alcantarillado sanitario en colonia Plan de Ayala, ampliación Huixmi; ubicada en la localidad de El Huixmí, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N417/N417.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N417/JAN417.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N417/APN417.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N417/FAN417.pdf`,
                       },
                    ],
                },
        // Licitación N416
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N416-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de la carretera Yolotepec - Ejido el Mezquital; en el municipio de Santiago de Anaya; ubicada en la localidad de Yolotepec, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N416/N416.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N416/JAN416.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N416/APN416.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N416/FAN416.pdf`,
                       },
                    ],
                },
        // Licitación N415
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N415-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de calle Principal, en la colonia San Cayetano; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N415/N415.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N415/JAN415.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N415/APN415.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N415/FAN415.pdf`,
                       },
                    ],
                },
        // Licitación N414
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N414-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Circuito 11 de Julio, colonia 11 de Julio; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N414/N414.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N414/JAN414.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N414/APN414.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N414/FAN414.pdf`,
                       },
                    ],
                },
        // Licitación N413
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N413-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en el Arenal, localidad Centro Cabecera, Barrio La Capilla, calle Sin Nombre; ubicada en la localidad y Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N413/N413.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N413/JAN413.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N413/APN413.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N413/FAN413.pdf`,
                       },
                    ],
                },
        // Licitación N412
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N412-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica Av. Ayuntamiento y Prolongación Ayuntamiento, en fraccionamiento Colosio, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N412/N412.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N412/JAN412.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N412/APN412.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N412/FAN412.pdf`,
                       },
                    ],
                },
        // Licitación N411
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N411-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 4 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en Chapantongo localidad Puerto Vallarta calle principal; ubicada en la localidad de Puerto Vallarta, Municipio de Chapantongo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N411/N411.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N411/JAN411.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N411/APN411.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }37/N411/FAN411.pdf`,
                    //    },
                    ],
                },
        // Licitación N410
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N410-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica Av. Piracantos (2 Cuerpos), en fraccionamiento Piracantos, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N410/N410.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N410/JAN410.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N410/APN410.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N410/FAN410.pdf`,
                       },
                    ],
                },
        // Licitación N409
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N409-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta de concreto hidráulico en la calle Heroico Colegio Militar del Km. 0+000 al Km. 0+250 y rehabilitación de áreas verdes y espacios públicos en la colonia Militar, municipio de Mineral de la Reforma; ubicada en la localidad de Colonia Militar, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N409/N409.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N409/JAN409.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N409/APN409.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N409/FAN409.pdf`,
                       },
                    ],
                },
        // Licitación N408
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N408-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica en tres calles Romero de Terreros, de Los Mineros y Lumbrera del Km. 0+000 Al Km. 0+550, colonia Los Tuzos, municipio de Mineral de la Reforma; ubicada en la localidad de Los Tuzos, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N408/N408.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N408/JAN408.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N408/APN408.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N408/FAN408.pdf`,
                       },
                    ],
                },
        // Licitación N407
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N407-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en El Arenal localidad El Rincón Libramiento La Peña El Rincón; ubicada en la localidad de El Rincón, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N407/N407.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N407/JAN407.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N407/APN407.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }37/N407/FAN407.pdf`,
                    //    },
                    ],
                },
        // Licitación N406
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N406-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de la C.E. Mixquiahuala - Tula (paso por Tlahuelilpan); ubicada en la localidad y Municipio de Tlahuelilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N406/N406.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N406/JAN406.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N406/APN406.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N406/FAN406.pdf`,
                       },
                    ],
                },
        // Licitación N405
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N405-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en El Arenal, localidad de San José Tepenene calle 20 de Noviembre; ubicada en la localidad de Ojo de Agua San José Tepenene, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N405/N405.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N405/JAN405.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N405/APN405.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N405/FAN405.pdf`,
                       },
                    ],
                },
        // Licitación N404
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N404-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica del Libramiento Oriente - La Loma de La Cruz - Universidad, municipio de Ixmiquilpan (segunda etapa); ubicada en la localidad de La Loma de la Cruz, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }37/N404/N404.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }37/N404/JAN404.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }37/N404/APN404.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }37/N404/FAN404.pdf`,
                       },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 036
            'numConvocatoria' : 'Convocatoria No. 036/2023.',
            'idConvocatoria' : 'Convocatoria36',
            'procedimientos' : [
        // Licitación N403
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N403-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Reconstrucción de la carretera Eloxochitlán - Juárez Hidalgo; en el Municipio de Juárez Hidalgo; ubicada en la localidad y Municipio de Juárez Hidalgo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N403/N403.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N403/JAN403.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N403/APN403.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N403/FAN403.pdf`,
                       },
                    ],
                },
        // Licitación N402
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N402-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica C.R. San Cristobal - Hualula; municipio de Metztitlán; ubicada en la localidad de San Cristóbal, Municipio de Metztitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N402/N402.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N402/JAN402.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N402/APN402.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N402/FAN402.pdf`,
                       },
                    ],
                },
        // Licitación N401
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N401-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica de 1.70 km de calle Plan de San Luis del km 0+000 al km. 1+700 en la col. 20 de Noviembre en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N401/N401.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N401/JAN401.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N401/APN401.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }36/N401/FAN401.pdf`,
                    //    },
                    ],
                },
        // Licitación N400
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N400-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Av. Ayuntamiento en fraccionamiento Colosio; municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N400/N400.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N400/JAN400.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N400/APN400.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N400/FAN400.pdf`,
                       },
                    ],
                },
        // Licitación N399
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N399-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico en calle Avenida Guadalupe en la colonia Guadalupe, municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N399/N399.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N399/JAN399.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N399/APN399.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N399/FAN399.pdf`,
                       },
                    ],
                },
        // Licitación N398
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N398-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Av. Miguel Hidalgo en la localidad de Tlapacoya; municipio de Pachuca de Soto; ubicada en la localidad de Santiago Tlapacoya, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N398/N398.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N398/JAN398.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N398/APN398.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N398/FAN398.pdf`,
                       },
                    ],
                },
        // Licitación N397
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N397-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico de calle Canarios y calle 24 de Febrero, San Antonio el Desmonte; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N397/N397.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N397/JAN397.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N397/APN397.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N397/FAN397.pdf`,
                       },
                    ],
                },
        // Licitación N396
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N396-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Vía de los Reyes, San Lucas Daxtha, en el municipio de Actopan; ubicada en la localidad de El Daxtha, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N396/N396.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N396/JAN396.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N396/APN396.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N396/FAN396.pdf`,
                       },
                    ],
                },
        // Licitación N395
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N395-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en la localidad de San Miguel Cerezo;en el Municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N395/N395.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N395/JAN395.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N395/APN395.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N395/FAN395.pdf`,
                       },
                    ],
                },
        // Licitación N394
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N394-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación del pavimento asfáltico de calle, en la localidad de Pozo Grande en el municipio de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N394/N394.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N394/JAN394.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N394/APN394.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N394/FAN394.pdf`,
                       },
                    ],
                },
        // Licitación N393
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N393-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle de Los Nogal; es de la localidad de los Remedios;en el municipio de Tasquillo; ubicada en la localidad de Remedios, Municipio de Tasquillo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N393/N393.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N393/JAN393.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N393/APN393.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N393/FAN393.pdf`,
                       },
                    ],
                },
        // Licitación N392
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N392-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de acceso a fraccionamiento Bosques del Peñar en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N392/N392.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N392/JAN392.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N392/APN392.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N392/FAN392.pdf`,
                       },
                    ],
                },
        // Licitación N391
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N391-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de calle principal colonia Santa Julia; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N391/N391.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N391/JAN391.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N391/APN391.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N391/FAN391.pdf`,
                       },
                    ],
                },
        // Licitación N390
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N390-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de calle principal, colonia Cubitos; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N390/N390.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N390/JAN390.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N390/APN390.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N390/FAN390.pdf`,
                       },
                    ],
                },
        // Licitación N389
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N389-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 27 de noviembre al 5 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica del Circuito Los Reyes, municipio de Cardonal (segunda etapa); ubicada en la localidad de Los Reyes, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }36/N389/N389.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }36/N389/JAN389.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }36/N389/APN389.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }36/N389/FAN389.pdf`,
                       },
                    ],
                },
            ],
    },        
    {
        // CONVOCATORIA NUM# 035
            'numConvocatoria' : 'Convocatoria No. 035/2023.',
            'idConvocatoria' : 'Convocatoria35',
            'procedimientos' : [
        // Licitación N388
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N388-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023',
                    'descripcionProcedimiento' : 'Construcción de lago artificial, fuentes, esculturas y servicios de control que se ubican en torno al pisal homenaje a la Mujer del Mundo, en Pachuca de Soto, Hgo; ubicada en la localidad y Municipio y Municipio Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N388/N388.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N388/JAN388.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N388/APN388.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N388/FAN388.pdf`,
                       },
                    ],
                },
        // Licitación N387
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N387-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Levantamiento topográfico para reconocimiento y delimitación de bienes inmuebles, propiedad de la Agencia de Desarrollo Valle de Plata; en el municipio de Zapotlán de Juárez; ubicada en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N387/N387.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N387/JAN387.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N387/APN387.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N387/FAN387.pdf`,
                       },
                    ],
                },
        // Licitación N386
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N386-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltico en San Salvador localidad San Antonio Abad camino por El Canal; ubicada en la localidad de San Antonio Abad, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N386/N386.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N386/JAN386.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N386/APN386.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N386/FAN386.pdf`,
                       },
                    ],
                },
        // Licitación N385
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N385-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en la calle Violeta, en la localidad de Xochihuacán; municipio de Epazoyucan; ubicada en la localidad de Xochihuacán [Fraccionamiento], Municipio de Epazoyucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N385/N385.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N385/JAN385.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N385/APN385.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N385/FAN385.pdf`,
                       },
                    ],
                },
        // Licitación N384
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N384-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica calle Juárez, localidad de Teofani; municipio de San Salvador; ubicada en la localidad de Teofani, Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N384/N384.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N384/JAN384.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N384/APN384.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N384/FAN384.pdf`,
                       },
                    ],
                },
        // Licitación N383
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N383-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de C.R. Crisolco - Tecacalax, en el municipio de Yahualica; ubicada en la localidad de Crisolco, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N383/N383.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N383/JAN383.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N383/APN383.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N383/FAN383.pdf`,
                       },
                    ],
                },
        // Licitación N382
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N382-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en la localidad de Tzinancatitla, en el municipio de Jaltocán; ubicada en la localidad de Tzinancatitla, Municipio de Jaltocán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N382/N382.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N382/JAN382.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N382/APN382.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }35/N382/FAN382.pdf`,
                    //    },
                    ],
                },
        // Licitación N381
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N381-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 de noviembre al 1 de diciembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de la C.E. Chimalpa - Cárdenas, en el municipio de Apan; ubicada en la localidad de Lázaro Cárdenas, Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N381/N381.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N381/JAN381.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N381/APN381.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N381/FAN381.pdf`,
                       },
                    ],
                },
        // Licitación N380
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N380-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Jazmines, en la localidad de Tenango; en el municipio de Tezontepec de Aldama; ubicada en la localidad de Tenango, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N380/N380.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N380/JAN380.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N380/APN380.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N380/FAN380.pdf`,
                       },
                    ],
                },
        // Licitación N379
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N379-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de acceso principal a colonia Loma Bonita; municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N379/N379.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N379/JAN379.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N379/APN379.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N379/FAN379.pdf`,
                       },
                    ],
                },
        // Licitación N378
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N378-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de calle principal en la colonia Real Toledo; municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N378/N378.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N378/JAN378.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N378/APN378.pdf`,
                       },
                    //    {
                    //        'resultado' : 'Fallo',
                    //        'urlresultado' : `${ ligabase }35/N378/FAN378.pdf`,
                    //    },
                    ],
                },
        // Licitación N377
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N377-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción con carpeta asfáltica en Av. San Alberto del Km. 0+000 al Km. 0+305 y Av. Santa Isabel del Km. 0+000 al Km. 0+400, colonia La Providencia; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N377/N377.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N377/JAN377.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N377/APN377.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N377/FAN377.pdf`,
                       },
                    ],
                },
        // Licitación N376
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N376-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Av. Federalismo, colonia El Palmar; en el municipio de Pachuca de Soto, ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N376/N376.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N376/JAN376.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N376/APN376.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N376/FAN376.pdf`,
                       },
                    ],
                },
        // Licitación N375
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N375-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle principal en la localidad de Coyametepec, en el municipio de Acaxochitlán; ubicada en la localidad de Coyametepec, Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N375/N375.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N375/JAN375.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N375/APN375.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N375/FAN375.pdf`,
                       },
                    ],
                },
        // Licitación N374
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N374-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Av. Principal, en la colonia Plutarco Elías Calles; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N374/N374.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N374/JAN374.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N374/APN374.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N374/FAN374.pdf`,
                       },
                    ],
                },
        // Licitación N373
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N373-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 30 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica en Av. Santa Fe del Km. 0+000 al Km. 0+860, colonia La Providencia; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }35/N373/N373.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }35/N373/JAN373.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }35/N373/APN373.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }35/N373/FAN373.pdf`,
                       },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 034
            'numConvocatoria' : 'Convocatoria No. 034/2023.',
            'idConvocatoria' : 'Convocatoria34',
            'procedimientos' : [
        // Licitación N372
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N372-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Reconstrucción del Boulevard Centenario de la Revolución de 1910; en el municipio de Pachuca de Soto; ubicada en la localidad y  Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N372/N372.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N372/JAN372.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N372/APN372.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N372/FAN372.pdf`,
                       },
                    ],
                },
        // Licitación N371
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N371-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle línea divisoria en tramo 1 (entre calle Art 1932 y calle Reforma) tramo 2 (entre calle Fco. Márquez y calle Juan Álvarez) en la localidad de San Pedro Huaquilpan; en el municipio de Zapotlán de Juárez; ubicada en la localidad de San Pedro Huaquilpan, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N371/N371.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N371/JAN371.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N371/APN371.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N371/FAN371.pdf`,
                       },
                    ],
                },
        // Licitación N370
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N370-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Modernización y ampliación del camino Mecatlán - Mesa Larga, tramo: del Km 0+000 al Km 1+500; en el municipio de Yahualica; ubicada en la localidad de Mesa Larga, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N370/N370.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N370/JAN370.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N370/APN370.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N370/FAN370.pdf`,
                       },
                    ],
                },
        // Licitación N369
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N369-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de calle y muro de contención San José, colonia Santa Cecilia, en el municipio de Zacualtipán de Ángeles; ubicada en la localidad de Zacualtipán,  Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N369/N369.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N369/JAN369.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N369/APN369.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N369/FAN369.pdf`,
                       },
                    ],
                },
        // Licitación N368
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N368-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica circuito Pirules, municipio de Tizayuca; ubicada en la localidad y  Municipio de Tizayuca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N368/N368.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N368/JAN368.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N368/APN368.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N368/FAN368.pdf`,
                       },
                    ],
                },
        // Licitación N367
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N367-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación del camino rural Teoxtitla - San Felipe; en el municipio de San Felipe Orizatlán; ubicada en la localidad de Teoxtitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N367/N367.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N367/JAN367.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N367/APN367.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N367/FAN367.pdf`,
                       },
                    ],
                },
        // Licitación N366
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N366-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en camino Xiloco – Macuxtepetla en tramo 1 del km 0+000 al km 0+883.85 y tramo del km 0+000 al km 0+530.60; municipio de Huejutla de Reyes; ubicada en la localidad de Ahuatitla I,  Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N366/N366.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N366/JAN366.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N366/APN366.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N366/FAN366.pdf`,
                       },
                    ],
                },
        // Licitación N365
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N365-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en la Calle Principal, en la localidad de La Escondida; en el municipio de Pisaflores; ubicada en la localidad de Escondida de San Rafael,  Municipio de Pisaflores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N365/N365.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N365/JAN365.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N365/APN365.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N365/FAN365.pdf`,
                       },
                    ],
                },
        // Licitación N364
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N364-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 29 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de la C.E. Apan – Emiliano Zapata; en el municipio de Emiliano Zapata; ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N364/N364.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N364/JAN364.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N364/APN364.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }34/N364/AMDAPN364.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N364/FAN364.pdf`,
                       },
                    ],
                },
        // Licitación N363
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N363-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Ampliación del sistema de agua potable en la localidad de Santa Rita, municipio de Zimapán; ubicada en la localidad de Santa Rita, Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N363/N363.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N363/JAN363.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N363/APN363.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N363/FAN363.pdf`,
                       },
                    ],
                },
        // Licitación N362
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N362-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en calle Diamante del Km. 0+000 al Km. 0+450, Fraccionamiento El Paraíso, municipio de Mineral de la Reforma; ubicada en la localidad de Santa María La Calera  Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N362/N362.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N362/JAN362.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N362/APN362.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N362/FAN362.pdf`,
                       },
                    ],
                },
        // Licitación N361
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N361-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle La Unión (carretera México-Tuxpan a La Unión); en el municipio de Singuilucan; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N361/N361.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N361/JAN361.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N361/APN361.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N361/FAN361.pdf`,
                       },
                    ],
                },
        // Licitación N360
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N360-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en camino principal Santa Catarina - Santa Ana Tzacuala, para beneficiar a la comunidad de Santa Catarina; en el municipio de Acaxochitlán; ubicada en la localidad de Santa Catarina,  Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N360/N360.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N360/JAN360.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N360/APN360.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N360/FAN360.pdf`,
                       },
                    ],
                },
        // Licitación N359
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N359-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción Santa Esperanza La Providencia. municipio de Mineral de la Reforma, Hidalgo; ubicada en la localidad de La Providencia Siglo XXI,  Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N359/N359.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N359/JAN359.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N359/APN359.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N359/FAN359.pdf`,
                       },
                    ],
                },
        // Licitación N358
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N358-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica de la calle Rio Tula, en la colonia San Juan; en el municipio de Tezontepec de Aldama; ubicada en la localidad de San Juan (Colonia),  Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N358/N358.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N358/JAN358.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N358/APN358.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N358/FAN358.pdf`,
                       },
                    ],
                },
        // Licitación N357
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N357-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica de la C.E. Cárdenas - San Juan Ixtilmaco, en el municipio de Apan; ubicada en la localidad de San Juan Ixtilmaco,  Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N357/N357.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N357/JAN357.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N357/APN357.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N357/FAN357.pdf`,
                       },
                    ],
                },
        // Licitación N356
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N356-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica en calle Francisco Javier Mina, en la localidad de Ixcuinquitlapilco; en el municipio de San Agustín Tlaxiaca; ubicada en la localidad de Ixcuinquitlapilco,  Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N356/N356.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N356/JAN356.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N356/APN356.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N356/FAN356.pdf`,
                       },
                    ],
                },
        // Licitación N355
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N355-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica en carretera Los Tuzos Entronque Carretero Pachuca – Cd. Sahagún del km. 0+000 al km.1+200, municipio de Mineral de la Reforma; ubicada en la localidad de Los Tuzos,  Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N355/N355.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N355/JAN355.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N355/APN355.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N355/FAN355.pdf`,
                       },
                    ],
                },
        // Licitación N354
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N354-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica acceso a la comunidad de Los Gemelos, en el municipio de Mineral de la Reforma; ubicada en la localidad de Forjadores de Pachuca,  Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }34/N354/N354.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }34/N354/JAN354.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }34/N354/APN354.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }34/N354/FAN354.pdf`,
                       },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 033
            'numConvocatoria' : 'Convocatoria No. 033/2023.',
            'idConvocatoria' : 'Convocatoria33',
            'procedimientos' : [
        // Licitación N353
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N353-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Estudios complementarios de factibilidad geológica y adecuación del proyecto para garantizar la impermeabilidad en la presa Zacualtipán de Ángeles, en la localidad de Panotlan; ubicado en la localidad de Barrio Panotlán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N353/N353.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N353/JAN353.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N353/APN353.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N353/FAN353.pdf`,
                       },
                    ],
                },
        // Licitación N352
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N352-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en calle Lázaro Cárdenas, colonia Rojo Gómez; en el municipio de Tetepango; ubicada en la localidad y Municipio de Tetepango, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N352/N352.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N352/JAN352.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N352/APN352.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N352/FAN352.pdf`,
                       },
                    ],
                },
        // Licitación N351
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N351-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Calvario en tramo 1 (entre calle Corregidora y parte alta de Calvario), tramo 2 (entre calle Matamoros y calle Ciprés) en la localidad de Acayuca; en el municipio de Zapotlán de Juárez; ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N351/N351.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N351/JAN351.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N351/APN351.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N351/FAN351.pdf`,
                       },
                    ],
                },
        // Licitación N350
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N350-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de muro de contención en cabecera municipal carretera La Misión - Puerto Naranjos; ubicada en la localidad y Municipio de La Misión, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N350/N350.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N350/JAN350.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N350/APN350.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N350/FAN350.pdf`,
                       },
                    ],
                },
        // Licitación N349
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N349-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Ampliación de la red de agua potable e interconexión a la red de CFE de paneles solares en la localidad de Cuesta Colorada en el municipio de Ixmiquilpan; ubicada en la localidad de Cuesta Colorada, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N349/N349.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N349/JAN349.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N349/APN349.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N349/FAN349.pdf`,
                       },
                    ],
                },
        // Licitación N348
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N348-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico en calle Camino Interparcelario del km. 0+000 al km. 0+350, Fraccionamiento El Paraíso, municipio de Mineral de la Reforma; ubicada en la localidad de Forjadores de Pachuca, Municipio Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N348/N348.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N348/JAN348.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N348/APN348.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N348/FAN348.pdf`,
                       },
                    ],
                },
        // Licitación N347
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N347-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de empedrado ahogado de camino San Isidro a colonia Guadalupe El Astillero; en el municipio de Nopala de Villagrán; ubicada en la localidad de San Isidro, Municipio de Nopala de Villagrán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N347/N347.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N347/JAN347.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N347/APN347.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N347/FAN347.pdf`,
                       },
                    ],
                },
        // Licitación N346
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N346-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 28 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica en calle General Nicolás Flores del km. 0+000 al km. 0+600 en la colonia Juan C. Doria, municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N346/N346.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N346/JAN346.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N346/APN346.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N346/FAN346.pdf`,
                       },
                    ],
                },
        // Licitación N345
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N345-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta de concreto hidráulico en calle Avenida Santiago Jaltepec del km 0+000 al km. 1+725 en la colonia Militar, municipio de Mineral de la Reforma; ubicada en la localidad de Santiago Jaltepec, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N345/N345.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N345/JAN345.pdf`,
                       },
                       {
                            'resultado' : 'Anexo Modificatorio',
                            'urlresultado' : `${ ligabase }33/N345/AMDJAN345.pdf`,
                        },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N345/APN345.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N345/FAN345.pdf`,
                       },
                    ],
                },
        // Licitación N344
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N344-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle 01 de Junio, en la localidad de El Mirador; en el municipio de Zempoala.; ubicada en la localidad de El Mirador, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N344/N344.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N344/JAN344.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N344/APN344.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N344/FAN344.pdf`,
                       },
                    ],
                },
        // Licitación N343
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N343-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carretera Villa de Tezontepec - Téllez (camino a Comunidades); en el municipio de Villa de Tezontepec; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N343/N343.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N343/JAN343.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N343/APN343.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N343/FAN343.pdf`,
                       },
                    ],
                },
        // Licitación N342
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N342-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Apertura de camino intermunicipal Tuzancocac (Xochicoatlán) - Tula (Calnai); ubicada en la localidad de Tuzancoac, Municipio de Xochicoatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N342/N342.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N342/JAN342.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N342/APN342.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N342/FAN342.pdf`,
                       },
                    ],
                },
        // Licitación N341
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N341-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento de concreto hidráulico del camino Francisco I. Madero; en el municipio de Mineral del Monte; ubicada en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N341/N341.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N341/JAN341.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N341/APN341.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N341/FAN341.pdf`,
                       },
                    ],
                },
        // Licitación N340
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N340-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de muros de contención en la comunidad de Tecolotitla; en el municipio de Atlapexco; ubicada en la localidad de Tecolotitla, Municipio de Atlapexco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N340/N340.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N340/JAN340.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N340/APN340.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N340/FAN340.pdf`,
                       },
                    ],
                },
        // Licitación N339
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N339-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimentación calle 18 de Julio, San Pedro Nopancalco, Pachuca de Soto; en el municipio de Pachuca de Soto; ubicada en la localidad de San Pedro (El Cigarro), Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N339/N339.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N339/JAN339.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N339/APN339.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N339/FAN339.pdf`,
                       },
                    ],
                },
        // Licitación N338
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N338-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en la calle de acceso principal a la localidad de La Ilusión - Anacleto Ramos - Potrero Zactipan - Octatitla; en el municipio de Jaltocán; ubicada en la localidad de La Ilusión, Municipio de Jaltocán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N338/N338.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N338/JAN338.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N338/APN338.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N338/FAN338.pdf`,
                       },
                    ],
                },
        // Licitación N337
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N337-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 20 al 27 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de pavimento asfáltico de la C.E. paso por Zimapán.; ubicada en la localidad de Lázaro Cárdenas (Remedios), Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }33/N337/N337.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }33/N337/JAN337.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }33/N337/APN337.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }33/N337/FAN337.pdf`,
                       },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 032
            'numConvocatoria' : 'Convocatoria No. 032/2023.',
            'idConvocatoria' : 'Convocatoria32',
            'procedimientos' : [
        // Licitación N336
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N336-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 22 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Construcción de instalaciones de servicios básicos y terracerías para el Centro Cultural y Recreativo, del Parque Ben Gurión, en Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de  Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N336/N336.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N336/JAN336.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N336/APN336.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N336/FAN336.pdf`,
                       },
                    ],
                },
        // Licitación N335
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N335-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 22 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de la calle 20 de Noviembre, en la localidad de Bangandhó, municipio de Ixmiquilpan; ubicada en la localidad de Bangandhó,  Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N335/N335.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N335/JAN335.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N335/APN335.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N335/FAN335.pdf`,
                       },
                    ],
                },
        // Licitación N334
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N334-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 22 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico tramo Velasco el Mirador; municipio de Omitlán de Juárez; ubicada en la localidad de Velasco, Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N334/N334.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N334/JAN334.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N334/APN334.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N334/FAN334.pdf`,
                       },
                    ],
                },
        // Licitación N333
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N333-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 22 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de carretera Ixmiquilpan - Capula, tramo del km 0+400 al km 2+100, en barrios San Miguel y El Nith, en el municipio de Ixmiquilpan; ubicada en la localidad de El Nith,  Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N333/N333.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N333/JAN333.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N333/APN333.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N333/FAN333.pdf`,
                       },
                    ],
                },
        // Licitación N332
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N332-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 22 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación asfáltica de la Av. Nicolas Bravo, Bo. Casa Grande en San Agustín Tlaxiaca; ubicada en la localidad de Casa Grande (Barrio),  Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N332/N332.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N332/JAN332.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N332/APN332.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N332/FAN332.pdf`,
                       },
                    ],
                },
        // Licitación N331
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N331-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 22 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Sustitución de alumbrado público en el Parque Industrial Metropolitano; en el municipio de Mineral de la Reforma; ubicada en la localidad de La Providencia Siglo XXI,  Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }32/N331/N331.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }32/N331/JAN331.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }32/N331/APN331.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }32/N331/FAN331.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 031
            'numConvocatoria' : 'Convocatoria No. 031/2023.',
            'idConvocatoria' : 'Convocatoria31',
            'procedimientos' : [
        // Licitación N330
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N330-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Reestructuración de puente del área de Coordinación de Enseñanza del Hospital del Niño DIF; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N330/N330.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N330/JAN330.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N330/APN330.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N330/FAN330.pdf`,
                       },
                    ],
                },
        // Licitación N329
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N329-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en camino Palo Gordo primera etapa, en el Municipio de Metepec; ubicada en la localidad de Palo Gordo (Ejido Nopalillo), Municipio de Metepec, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }31/N329/N329.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N329/JAN329.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N329/APN329.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N329/FAN329.pdf`,
                       },
                    ],
                },
        // Licitación N328
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N328-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de estacionamiento y andadores ubicados en torno al Auditorio Gota de Plata, en Pachuca de Soto, Hgo.; ubicada en la localidad y  Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N328/N328.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N328/JAN328.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N328/APN328.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N328/FAN328.pdf`,
                       },
                    ],
                },
        // Licitación N327
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N327-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica en calle Quetzalcoatl del Km. 0+000 al Km. 0+756, municipio de Mineral de la Reforma; ubicada en la localidad de Forjadores de Pachuca, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N327/N327.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N327/JAN327.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N327/APN327.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N327/FAN327.pdf`,
                       },
                    ],
                },
        // Licitación N326
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N326-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Sin Nombre (La Monera) en el municipio de Zapotlán de Juárez; ubicada en la localidad  y Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N326/N326.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N326/JAN326.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N326/APN326.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N326/FAN326.pdf`,
                       },
                    ],
                },
        // Licitación N325
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N325-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción de acceso a las col. de Satelite, Violetas, Galaxia I y Galaxia II, en el municipio de Tula de Allende; ubicada en varias localidades del  Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N325/N325.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N325/JAN325.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N325/APN325.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N325/FAN325.pdf`,
                       },
                    ],
                },
        // Licitación N324
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N324-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción del Sistema de Alcantarillado Sanitario y Rehabilitación de Planta de Tratamiento de Aguas Residuales (2da etapa) para beneficiar a la localidad de Villa Hermosa; en el municipio de Nicolás Flores; ubicada en la localidad  Villa Hermosa, Municipio de Nicolás Flores, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N324/N324.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N324/JAN324.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N324/APN324.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N324/FAN324.pdf`,
                       },
                    ],
                },
        // Licitación N323
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N323-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica Av. 16 de Septiembre, colonia Centro; en el municipio de Tlaxcoapan; ubicada en la localidad y  Municipio de Tlaxcoapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N323/N323.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N323/JAN323.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N323/APN323.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N323/FAN323.pdf`,
                       },
                    ],
                },
        // Licitación N322
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N322-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Modernización del camino rural los Parajes - Chalahuiyapa; en el municipio de Huejutla de Reyes; ubicada en la localidad  de Los Parajes Benito Juárez, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N322/N322.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N322/JAN322.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N322/APN322.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N322/FAN322.pdf`,
                       },
                    ],
                },
        // Licitación N321
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N321-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de calle Otomíes, en la colonia La Noria de Taxhuada, municipio de Mixquiahuala; ubicada en la localidad  y  Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N321/N321.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N321/JAN321.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N321/APN321.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N321/FAN321.pdf`,
                       },
                    ],
                },
        // Licitación N320
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N320-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de acceso al COBAEH de San Ildefonso, en el municipio de Tepeji del Rio; ubicada en la localidad de San Ildefonso, Municipio de Tepeji del Rio de Ocampo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N320/N320.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N320/JAN320.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N320/APN320.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N320/FAN320.pdf`,
                       },
                    ],
                },
        // Licitación N319
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N319-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en la antigua carretera a Santa Elena Paliseca ubicada en la Localidad de Santa Elena Paliseca, municipio de Cuautepec de Hinojosa; ubicada en la localidad de Santa Elena Paliseca, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N319/N319.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N319/JAN319.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N319/APN319.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N319/FAN319.pdf`,
                       },
                    ],
                },
        // Licitación N318
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N318-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Pedro Escobedo del Km. 0+000 al Km. 0+500 en colonia Barrio El Lobo, municipio de Pachuca de Soto, Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N318/N318.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N318/JAN318.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N318/APN318.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N318/FAN318.pdf`,
                       },
                    ],
                },
        // Licitación N317
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N317-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Venustiano Carranza, en el municipio de Zempoala; ubicada en la localidad de Santa María Tecajete, Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N317/N317.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N317/JAN317.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N317/APN317.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N317/FAN317.pdf`,
                       },
                    ],
                },
        // Licitación N316
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N316-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de calle principal, colonia El Arbolito; en el municipio de Pachuca de Soto; ubicada en la localidad  y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N316/N316.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N316/JAN316.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N316/APN316.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N316/FAN316.pdf`,
                       },
                    ],
                },
        // Licitación N315
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N315-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica en calle Emiliano Zapata, en la cabecera municipal; en el municipio de Zempoala; ubicada en la localidad  y Municipio de Zempoala, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N315/N315.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N315/JAN315.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N315/APN315.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N315/FAN315.pdf`,
                       },
                    ],
                },
        // Licitación N314
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N314-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento asfaltico en calle de Las Flores y calle Olímpica, en la localidad de Acayuca; en el municipio de Zapotlán de Juárez; ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N314/N314.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N314/JAN314.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N314/APN314.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N314/FAN314.pdf`,
                       },
                    ],
                },
        // Licitación N313
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N313-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 21 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en calle Solidaridad del Km. 0+000 al Km. 0+372 en la colonia El Saucillo, municipio de Mineral de la Reforma; ubicada en la localidad de El Saucillo, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }31/N313/N313.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }31/N313/JAN313.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }31/N313/APN313.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }31/N313/FAN313.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 030
            'numConvocatoria' : 'Convocatoria No. 030/2023.',
            'idConvocatoria' : 'Convocatoria30',
            'procedimientos' : [
        // Licitación N312
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N312-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Reconstrucción de carpeta asfáltica de la Carretera San Salvador-San Miguel Acambay, municipio de San Salvador; ubicada en la localidad y Municipio de San Salvador, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N312/N312.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N312/JAN312.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N312/APN312.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N312/FAN312.pdf`,
                       },
                    ],
                },
        // Licitación N311
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N311-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en El Arenal, Barrio El Ojua calle Lázaro Cárdenas; ubicada en la localidad de El Ojua, Municipio de El Arenal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N311/N311.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N311/JAN311.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N311/APN311.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N311/FAN311.pdf`,
                       },
                    ],
                },
        // Licitación N310
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N310-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación hidráulica, guarniciones, banquetas y muro de mampostería en Calle Manuel F. Soto, en el municipio de Acaxochitlán; ubicada en la localidad y Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N310/N310.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N310/JAN310.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N310/APN310.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N310/FAN310.pdf`,
                       },
                    ],
                },
        // Licitación N309
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N309-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de concreto hidráulico en la calle Venustiano Carranza colonia El Saucillo, municipio de Mineral de la Reforma, Hidalgo; ubicada en la localidad de El Saucillo, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N309/N309.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N309/JAN309.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N309/APN309.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N309/FAN309.pdf`,
                       },
                    ],
                },
        // Licitación N308
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N308-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica con riego de sello en calle Circuito Santa Cecilia del Km 1+200 Al Km. 1+930, La Providencia, municipio de Mineral de la Reforma; ubicada en la localidad de La Providencia Siglo XXI, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N308/N308.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N308/JAN308.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N308/APN308.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N308/FAN308.pdf`,
                       },
                    ],
                },
        // Licitación N307
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N307-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de carretera de acceso a Malayerba; en el municipio de Apan; ubicada en la localidad de Malayerba, Municipio de Apan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N307/N307.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N307/JAN307.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N307/APN307.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N307/FAN307.pdf`,
                       },
                    ],
                },
        // Licitación N306
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N306-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica, en acceso a Universidad del Bienestar, municipio de San Felipe Orizatlán; ubicada en la localidad de Ahuatitla, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N306/N306.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N306/JAN306.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N306/APN306.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N306/FAN306.pdf`,
                       },
                    ],
                },
        // Licitación N305
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N305-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de carpeta asfáltica del tramo C.E. Chalahuiyapa - Los Otates del 0+000 al 3+800; en el municipio de Huejutla de Reyes; ubicada en la localidad de Chalahuiyapa, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N305/N305.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N305/JAN305.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N305/APN305.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N305/FAN305.pdf`,
                       },
                    ],
                },
        // Licitación N304
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N304-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Jaspe, en el municipio de Tepeapulco; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N304/N304.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N304/JAN304.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }30/N304/AMDJAN304.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N304/APN304.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N304/FAN304.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }30/N304/AMDFAN304.pdf`,
                    },
                    ],
                },
        // Licitación N303
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N303-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Mirto, en el municipio de Tepeapulco; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N303/N303.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N303/JAN303.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N303/APN303.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N303/FAN303.pdf`,
                       },
                    ],
                },
        // Licitación N302
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N302-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica   en calle Sinaloa “Camino Blanco”, localidad Dengantzha, municipio de Francisco I. Madero; ubicada en la localidad de Dengantzha, Municipio de Francisco I. Madero, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N302/N302.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N302/JAN302.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N302/APN302.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N302/FAN302.pdf`,
                       },
                    ],
                },
        // Licitación N301
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N301-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación de calle cerrada de Los Girasoles, colonia López Mateos Segunda Sección, en el municipio de Zacualtipán de Ángeles; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N301/N301.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N301/JAN301.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N301/APN301.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N301/FAN301.pdf`,
                       },
                    ],
                },
        // Licitación N300
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N300-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento hidráulico en calle Álamos, en el municipio de Tepeapulco; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N300/N300.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N300/JAN300.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N300/APN300.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N300/FAN300.pdf`,
                       },
                    ],
                },
        // Licitación N299
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N299-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación del tramo de acceso a Tecueyaca, del Km 0+000 al km 6+000; en el Municipio de Calnali.; ubicada en la localidad de Tecueyaca, Municipio de Calnali, Estado de Hidalgo. Segundo Procedimiento.',
                    'urlAnexos' : `${ ligabase }30/N299/N299.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N299/JAN299.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N299/APN299.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N299/FAN299.pdf`,
                       },
                    ],
                },
        // Licitación N298
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N298-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontológico Integral de Huejutla.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N298/N298.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N298/JAN298.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N298/APN298.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N298/FAN298.pdf`,
                       },
                    ],
                },
        // Licitación N297
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N297-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 17 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación de Centro Gerontológico de Zacualtipán.; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }30/N297/N297.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }30/N297/JAN297.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }30/N297/APN297.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }30/N297/FAN297.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 029
            'numConvocatoria' : 'Convocatoria No. 029/2023.',
            'idConvocatoria' : 'Convocatoria29',
            'procedimientos' : [
        // Licitación N296
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N296-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 10 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Habilitación de infraestructura para el manejo integral de los residuos sólidos urbanos del municipio de Huehuetla; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }29/N296/N296.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N296/JAN296.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N296/APN296.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N296/FAN296.pdf`,
                       },
                    ],
                },
        // Licitación N295
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N295-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 10 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Señalamiento horizontal y vertical en avenida de acceso.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N295/N295.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N295/JAN295.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N295/APN295.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N295/FAN295.pdf`,
                       },
                    ],
                },
        // Licitación N294
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N294-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 10 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Adecuación de la red principal de agua (Tramo Oriente); ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N294/N294.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N294/JAN294.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N294/APN294.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N294/FAN294.pdf`,
                       },
                    ],
                },
        // Licitación N293
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N293-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 10 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Reconstrucción con Concreto Hidráulico en Avenida Diesel Nacional.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N293/N293.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N293/JAN293.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N293/APN293.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N293/FAN293.pdf`,
                       },
                    ],
                },
        // Licitación N292
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N292-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 10 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Alumbrado en el acceso poniente; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }29/N292/N292.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }29/N292/JAN292.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }29/N292/APN292.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }29/N292/FAN292.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 028
            'numConvocatoria' : 'Convocatoria No. 028/2023.',
            'idConvocatoria' : 'Convocatoria28',
            'procedimientos' : [
        // Licitación N291
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N291-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 8 de noviembre de 2023',
                    'descripcionProcedimiento' : 'Modernización del camino rural Xuchitlan - Toscalao, subtramo: Toscalao - Tetlapaya; ubicada en la localidad de Xuchitlán, Municipio de Lolotla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N291/N291.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N291/JAN291.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N291/APN291.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N291/FAN291.pdf`,
                       },
                    ],
                },
        // Licitación N290
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N290-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 8 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica de acceso a Base de Operaciones Mixtas Tulancingo.; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N290/N290.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N290/JAN290.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N290/APN290.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N290/FAN290.pdf`,
                       },
                    ],
                },
        // Licitación N289
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N289-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 8 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de la Planta de Tratamiento zona norte para beneficiar a la localidad de Acatepec en el Municipio de Huautla; ubicada en la localidad de Acatepec, Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N289/N289.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N289/JAN289.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N289/APN289.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N289/FAN289.pdf`,
                       },
                    ],
                },
        // Licitación N288
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N288-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 8 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de la Planta de Tratamiento de Aguas Residuales para beneficiar a la localidad de Atlalco en el Municipio de Yahualica; ubicada en la localidad de Atlalco, Municipio de Yahualica, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N288/N288.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N288/JAN288.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N288/APN288.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N288/FAN288.pdf`,
                       },
                    ],
                },
        // Licitación N287
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N287-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 8 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de calle Felipe Ángeles a Hidroeléctrica Elba: Tramo 0+000 - 1+680; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N287/N287.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N287/JAN287.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N287/APN287.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N287/FAN287.pdf`,
                       },
                    ],
                },
        // Licitación N286
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N286-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de pavimento en calle Francisco Villa, Col. El Venado, tramo dos; en el municipio de Mineral de la Reforma; ubicada en la localidad de El Venado, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N286/N286.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N286/JAN286.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N286/APN286.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N286/FAN286.pdf`,
                       },
                    ],
                },
        // Licitación N285
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N285-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de Pavimento en Calle Francisco Villa, Col. El Venado, Tramo Uno; en el Municipio de Mineral de la Reforma; ubicada en la localidad de El Venado, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N285/N285.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N285/JAN285.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N285/APN285.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N285/FAN285.pdf`,
                       },
                    ],
                },
        // Licitación N284
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N284-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de alcantarillado sanitario y Planta de tratamiento de aguas residuales Centro en Caltimacán, municipio de Tasquillo; ubicada en la localidad de Caltimacán, Municipio de Tasquillo, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }28/N284/N284.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N284/JAN284.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N284/APN284.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N284/FAN284.pdf`,
                       },
                    ],
                },
        // Licitación N283
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N283-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción del Sistema de Alcantarillado Sanitario primera etapa para beneficiar a la localidad de El Mejay en el municipio de Chilcuautla; ubicada en la localidad de El Mejay, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N283/N283.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N283/JAN283.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N283/APN283.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N283/FAN283.pdf`,
                       },
                    ],
                },
        // Licitación N282
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N282-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción de la Red de Alcantarillado Sanitario en diversos sectores para beneficiar a la localidad de Acatepec en el municipio de Huautla.; ubicada en la localidad de Acatepec, Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N282/N282.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N282/JAN282.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N282/APN282.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N282/FAN282.pdf`,
                       },
                    ],
                },
        // Licitación N281
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N281-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Construcción del Sistema de Agua Potable para beneficiar a la localidad de Tepepa Santiago Tepepa segunda etapa consiste en red de distribución en varias AGEBS; ubicada en la localidad de Tepepa, Municipio de Acaxochitlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }28/N281/N281.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N281/JAN281.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N281/APN281.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N281/FAN281.pdf`,
                       },
                    ],
                },
        // Licitación N280
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N280-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 30 de octubre al 7 de noviembre de 2023.',
                    'descripcionProcedimiento' : 'Rehabilitación del tramo Tzapotitla - Tlatzonco del km 0+000 al km 2+300; en el municipio de Huazalingo; ubicada en la localidad de Tzapotitla, Municipio de Huazalingo, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }28/N280/N280.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }28/N280/JAN280.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }28/N280/APN280.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }28/N280/FAN280.pdf`,
                       },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 027
            'numConvocatoria' : 'Convocatoria No. 027/2023.',
            'idConvocatoria' : 'Convocatoria27',
            'procedimientos' : [
        // Licitación N279
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N279-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Rehabilitación de Plazoleta Benito Juárez; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N279/N279.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N279/JAN279.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N279/APN279.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N279/FAN279.pdf`,
                       },
                    ],
                },
        // Licitación N278
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N278-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Pavimentación asfáltica en calle Palma, en la localidad de El Huaxtho; en el municipio de Actopan.; ubicada en la localidad de El Huaxtho, Municipio de Actopan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N278/N278.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N278/JAN278.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N278/APN278.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N278/FAN278.pdf`,
                       },
                    ],
                },
        // Licitación N277
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N277-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Reconstrucción de pavimento asfaltico de avenida Liberación Nacional, en la localidad de El Llano Primera Sección, municipio de Tula de Allende; ubicada en la localidad de El Llano, Municipio de Tula de Allende, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }27/N277/N277.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N277/JAN277.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N277/APN277.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N277/FAN277.pdf`,
                       },
                    ],
                },
        // Licitación N276
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N276-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en camino rural al pozo de agua potable en la comunidad de El Bethí; en el municipio del Chilcuautla; ubicada en la localidad de El Bethí, Municipio de Chilcuautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N276/N276.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N276/JAN276.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N276/APN276.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N276/FAN276.pdf`,
                       },
                    ],
                },
        // Licitación N275
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N275-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en camino Palo Gordo primera etapa, en el Municipio de Metepec; ubicada en la localidad de Palo Gordo (Ejido Nopalillo), Municipio de Metepec, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N275/N275.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N275/JAN275.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N275/APN275.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N275/FAN275.pdf`,
                       },
                    ],
                },
        // Licitación N274
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N274-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Construcción de barda perimetral y pavimento en el Mercado Municipal, de Almoloya.; ubicada en la localidad y Municipio de Almoloya, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N274/N274.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N274/JAN274.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N274/APN274.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N274/FAN274.pdf`,
                       },
                    ],
                },
        // Licitación N273
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N273-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Rehabilitación del tramo E.C. (Atlapexco-Huautla) - Xionaxtla, del km 0+000 al km 3+000; en el municipio de Huejutla.; ubicada en la localidad de Xionaxtla, Municipio de Huejutla de Reyes, Estado de Hidalgo. Segundo procedimiento.',
                    'urlAnexos' : `${ ligabase }27/N273/N273.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N273/JAN273.pdf`,
                       },
                       {
                           'resultado' : 'Anexo modificatorio',
                           'urlresultado' : `${ ligabase }27/N273/AMDJAN273.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N273/APN273.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N273/FAN273.pdf`,
                       },
                    ],
                },
        // Licitación N272
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N272-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 23 de octubre de 2023',
                    'descripcionProcedimiento' : 'Ampliación del sistema de Agua Potable para beneficiar a la localidad de San Miguel Tlazintla en el Municipio de Cardonal; ubicada en la localidad de San Miguel Tlazintla, Municipio de Cardonal, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N272/N272.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N272/JAN272.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N272/APN272.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N272/FAN272.pdf`,
                       },
                    ],
                },
        // Licitación N271
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N271-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Construcción de vialidad interior del Centro Deportivo Hidalguense y de Alto Rendimiento; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N271/N271.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N271/JAN271.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N271/APN271.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N271/FAN271.pdf`,
                       },
                    ],
                },
        // Licitación N270
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N270-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Pavimentación de Concreto Hidráulico tramo La Iglesia, en la localidad de Puentecillas; municipio de Omitlán de Juárez; ubicada en la localidad de Puentecillas, Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N270/N270.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N270/JAN270.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N270/APN270.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N270/FAN270.pdf`,
                       },
                    ],
                },
        // Licitación N269
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N269-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Construcción del camino Santa Ana - La Labor; ubicada en la localidad de Santa Ana, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N269/N269.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N269/JAN269.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N269/APN269.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N269/FAN269.pdf`,
                       },
                    ],
                },
        // Licitación N268
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N268-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Rehabilitación del Auditorio de la Comunidad de Doxey, en el municipio de Tlaxcoapan; ubicada en la localidad de Doxey, Municipio de Tlaxcoapan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N268/N268.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N268/JAN268.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N268/APN268.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N268/FAN268.pdf`,
                       },
                    ],
                },
        // Licitación N267
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N267-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Sistema de agua potable Pozo la Cebada, línea de alimentación y red de distribución; ubicada en la localidad de La Cebada, Municipio de Zimapán, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N267/N267.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N267/JAN267.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N267/APN267.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N267/FAN267.pdf`,
                       },
                    ],
                },
        // Licitación N266
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N266-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Rehabilitación del tramo de acceso a Tecueyaca, del Km 0+000 al km 6+000; en el Municipio de Calnali.; ubicada en la localidad de Tecueyaca, Municipio de Calnali, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N266/N266.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N266/JAN266.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N266/APN266.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N266/FAN266.pdf`,
                       },
                    ],
                },
        // Licitación N265
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N265-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Rehabilitación de Carpeta Asfáltica en la Calle Felipe Angeles, en la Colonia Periodistas, en el Municipio de Pachuca..; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N265/N265.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N265/JAN265.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N265/APN265.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }27/N265/AMDAPN265.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N265/FAN265.pdf`,
                       },
                    ],
                },
        // Licitación N264
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N264-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Reconstrucción de la Autopista Turística de la Montaña (Cuerpo A); ubicada en la localidad de San Guíllermo la Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N264/N264.rar`,
                    'resultados' : [
                        {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N264/JAN264.pdf`,
                        },
                        {
                        'resultado' : 'Aclaraciones 2da.',
                        'urlresultado' : `${ ligabase }27/N264/JA2N264.pdf`,
                        },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N264/APN264.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N264/FAN264.pdf`,
                       },
                    ],
                },
        // Licitación N263
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SIPDUS-N263-2023.',
                    'vigencia' : 'Vigencia de venta de bases: del 16 al 20 de octubre de 2023',
                    'descripcionProcedimiento' : 'Construcción del Boulevard de acceso al Huixmi, en el municipio de Pachuca de Soto; ubicada en la localidad de El Huixmí, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }27/N263/N263.rar`,
                    'resultados' : [
                       {
                           'resultado' : 'Aclaraciones',
                           'urlresultado' : `${ ligabase }27/N263/JAN263.pdf`,
                       },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }27/N263/APN263.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }27/N263/FAN263.pdf`,
                       },
                    ],
                },
            ],
        },
    {
        // CONVOCATORIA NUM# 026
        'numConvocatoria': 'Convocatoria No. 026/2023.',
        'idConvocatoria': 'Convocatoria26',
        'procedimientos': [
            // Licitación N262
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N262-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico camino Santa Mónica-Escobillas; en el municipio de Epazoyucan.; ubicada en la localidad de Escobillas, Municipio de Epazoyucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N262/N262.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N262/JAN262.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N262/APN262.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N262/FAN262.pdf`,
                       },
                ],
            },
            // Licitación N261
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N261-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Maravillas - Limites del Estado de Hidalgo (El Tepeyac); ubicada en la localidad de Maravillas, Municipio de Nopala de Villagrán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N261/N261.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N261/JAN261.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N261/APN261.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N261/FAN261.pdf`,
                       },
                ],
            },
            // Licitación N260
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N260-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Construcción de alcantarillado sanitario y Planta de tratamiento de aguas residuales Centro en Caltimacán, municipio de Tasquillo; ubicada en la localidad de Caltimacán, Municipio de Tasquillo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N260/N260.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N260/JAN260.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N260/APN260.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N260/FAN260.pdf`,
                       },
                ],
            },
            // Licitación N259
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N259-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Agua Blanca-Zacualpa; en el municipio de Agua Blanca; ubicada en Varias localidades del Municipio de Agua Blanca de Iturbide, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N259/N259.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N259/JAN259.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N259/APN259.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N259/FAN259.pdf`,
                       },
                ],
            },
            // Licitación N258
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N258-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Mejoramiento y adecuación de la red de alcantarillado del centro del municipio de Tula de Allende; ubicada en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N258/N258.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N258/JAN258.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N258/APN258.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N258/FAN258.pdf`,
                       },
                ],
            },
            // Licitación N257
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N257-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Construcción del Sistema de Alcantarillado Sanitario consiste en el emisor para beneficiar a la comunidad de Atlaco, en el municipio de Yahualica; ubicada en la localidad de Atlalco, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N257/N257.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N257/JAN257.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N257/APN257.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N257/FAN257.pdf`,
                       },
                ],
            },
            // Licitación N256
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N256-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Construcción de Sanitario con Biodigestor, en el municipio de Xochiatipan; ubicada en Varias localidades del Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N256/N256.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N256/JAN256.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N256/APN256.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N256/FAN256.pdf`,
                       },
                ],
            },
            // Licitación N255
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N255-2023.',
                'vigencia': 'Vigencia de venta de bases: del 2 al 6 de octubre de 2023',
                'descripcionProcedimiento': 'Mejoramiento y ampliación al CERESO Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}26/N255/N255.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}26/N255/JAN255.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }26/N255/APN255.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }26/N255/FAN255.pdf`,
                       },
                ],
            },
        ],
    },
    {
        // CONVOCATORIA NUM# 025
        'numConvocatoria': 'Convocatoria No. 025/2023.',
        'idConvocatoria': 'Convocatoria25',
        'procedimientos': [
            // Licitación N254
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N254-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Pavimentación Hidráulica en la Calle 8 en la Colonia Parque de Poblamiento, en el Municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N254/N254.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N254/JAN254.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N254/APN254.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N254/FAN254.pdf`,
                       },
                ],
            },
            // Licitación N253
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N253-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Construcción de banquetas y guarniciones en camino Acalome- Pilas y Granadas en el municipio de Metztitlan.; ubicada en la localidad de Pilas y Granadas, Municipio de Metztitlán, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N253/N253.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N253/JAN253.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N253/APN253.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N253/FAN253.pdf`,
                       },
                       {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }25/N253/AMDFAN253.pdf`,
                    },
                ],
            },
            // Licitación N252
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N252-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Construcción de drenaje pluvial (alcantarilla tipo bóveda) en Camino de Acceso Principal a la localidad El Piñal, San Bartolo Tutotepec.; ubicada en la localidad de El Piñal, Municipio de San Bartolo Tutotepec, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N252/N252.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N252/JAN252.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N252/APN252.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N252/FAN252.pdf`,
                       },
                ],
            },
            // Licitación N251
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N251-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Impermeabilización De losa de techo de la Secretaría de Seguridad Pública de Hidalgo, en Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N251/N251.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N251/JAN251.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N251/APN251.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N251/FAN251.pdf`,
                       },
                ],
            },
            // Licitación N250
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N250-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Construcción de dormitorios CERESO Pachuca de Soto Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N250/N250.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N250/JAN250.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N250/APN250.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N250/FAN250.pdf`,
                       },
                ],
            },
            // Licitación N249
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N249-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Rehabilitación de luminarias en el DESCTI.; de Cobertura Estatal. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N249/N249.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N249/JAN249.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N249/APN249.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N249/FAN249.pdf`,
                       },
                ],
            },
            // Licitación N248
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N248-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Pavimentación asfáltica del tramo del Chabacano-La Conchita del Km 0+000 al Km 1+495; ubicada en la localidad de La Conchita (La Cantera), Municipio de Singuilucan, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N248/N248.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N248/JAN248.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N248/APN248.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N248/FAN248.pdf`,
                       },
                ],
            },
            // Licitación N247
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N247-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Reconstrucción del camino Gandhó - Rancho Viejo - El Geiser - La Salitrera - Uxdejhe (Estatal 101) del Km 0+000 Al Km 4+000, en el municipio Tecozautla.; ubicada en Varias localidades del Municipio de Tecozautla, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N247/N247.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N247/JAN247.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N247/APN247.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N247/FAN247.pdf`,
                       },
                ],
            },
            // Licitación N246
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N246-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica en Calle Temazola, en el municipio de Metztitlán.; ubicada en Varias localidades del Municipio de Metztitlán, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}25/N246/N246.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N246/JAN246.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N246/APN246.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N246/FAN246.pdf`,
                       },
                ],
            },
            // Licitación N245
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N245-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Rehabilitación del Sistema de Agua Potable de la localidad de La Reforma, municipio de Tepehuacán de Guerrero; ubicada en la localidad de La Reforma, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}25/N245/N245.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N245/JAN245.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N245/APN245.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N245/FAN245.pdf`,
                       },
                ],
            },
            // Licitación N244
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N244-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (San Pedro - Huazalingo) - Tetlicuil, del km 0+000 al km 2+600; en el municipio de Huazalingo; ubicada en la localidad de Tetlicuil, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}25/N244/N244.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N244/JAN244.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N244/APN244.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N244/FAN244.pdf`,
                       },
                ],
            },
            // Licitación N243
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N243-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Rehabilitación del tramo Tzapotitla - Tlatzonco del km 0+000 al km 2+300; en el municipio de Huazalingo; ubicada en la localidad de Tzapotitla, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}25/N243/N243.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N243/JAN243.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N243/APN243.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N243/FAN243.pdf`,
                       },
                ],
            },
            // Licitación N242
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N242-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en la localidad del Comanche, municipio de Omitlán de Juárez; ubicada en la localidad de El Comanche, Municipio de Omitlán de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}25/N242/N242.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N242/JAN242.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N242/APN242.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N242/FAN242.pdf`,
                       },
                ],
            },
            // Licitación N241
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N241-2023.',
                'vigencia': 'Vigencia de venta de bases: del 25 al 29 de septiembre de 2023',
                'descripcionProcedimiento': 'Pavimentación con concreto hidráulico en calle Julian Villagrán entre calle Zacatecas y calle Guelatao, colonia El Salitre; en el municipio de Ajacuba; ubicada en la localidad y Municipio de Ajacuba, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}25/N241/N241.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}25/N241/JAN241.pdf`,
                    },
                       {
                           'resultado' : 'Apertura',
                           'urlresultado' : `${ ligabase }25/N241/APN241.pdf`,
                       },
                       {
                           'resultado' : 'Fallo',
                           'urlresultado' : `${ ligabase }25/N241/FAN241.pdf`,
                       },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 024/2023',
        'idConvocatoria': 'Convocatoria24',
        'procedimientos': [
            //Licitación N240
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N240-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle del Moral entre Río y calle Bugambilia, col. El Paraíso, municipio de Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo. (Segundo Procedimiento).',
                'urlAnexos': `${ligabase}24/N240/N240.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N240/JAN240.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N240/APN240.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N240/FAN240.pdf`,
                    },
                ],
            },
            //Licitación N239
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N239-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Modernización y Ampliación del C.R. Pozuelos - El Palmar; Tramo del km 0+000 al 12+209, Subtramo: del km 0+000 al 6+763.21, en el Municipio de Cardonal.; ubicada en la localidad de Pozuelos, Municipio de Cardonal, Estado de Hidalgo. (Segundo Procedimiento).',
                'urlAnexos': `${ligabase}24/N239/N239.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N239/JAN239.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N239/APN239.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N239/FAN239.pdf`,
                    },
                ],
            },
            //Licitación N238
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N238-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de la Autopista Turística de la Montaña (Cuerpo B).; ubicada en la localidad de San Guillermo La Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo. (Segundo Procedimiento)',
                'urlAnexos': `${ligabase}24/N238/N238.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N238/JAN238.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N238/APN238.pdf`,
                    },
                ],
            },
            //Licitación N237
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N237-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación de acceso a la Universidad Benito Juárez, Plantel Tlanchinol; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo. (Segundo Procedimiento)',
                'urlAnexos': `${ligabase}24/N237/N237.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N237/JAN237.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N237/APN237.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N237/FAN237.pdf`,
                    },
                ],
            },
            //Licitación N236
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N236-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Tula de Allende - Zaragoza; en el municipio de Tula de Allende; ubicada en Varias localidades del Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N236/N236.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N236/JAN236.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N236/APN236.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N236/FAN236.pdf`,
                    },
                ],
            },
            //Licitación N235
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N235-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación C.E. Santa María Temaxcalapa - Huehuetla, Subtramo del km 5+900 al km 10+000; en el municipio de Huehuetla; ubicada en la localidad y Municipio de Huehuetla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N235/N235.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N235/JAN235.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N235/APN235.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N235/FAN235.pdf`,
                    },
                ],
            },
            //Licitación N234
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N234-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del Polideportivo en cabecera municipal de Tepetitlán.; ubicada en la localidad y Municipio de Tepetitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N234/N234.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N234/JAN234.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N234/APN234.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N234/FAN234.pdf`,
                    },
                ],
            },
            //Licitación N233
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N233-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Perforación de pozo profundo de agua potable, para uso urbano, primera etapa, en la localidad de El Jagüey, Municipio de Nopala de Villagran, Hgo.; ubicada en la localidad de El Jagüey, Municipio de Nopala de Villagrán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N233/N233.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N233/JAN233.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N233/APN233.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N233/FAN233.pdf`,
                    },
                ],
            },
            //Licitación N232
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N232-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de pavimento asfaltico de avenida Liberación Nacional, en la localidad de El Llano Primera Sección, municipio de Tula de Allende; ubicada en la localidad de El Llano, Municipio de Tula de Allende, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N232/N232.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N232/JAN232.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N232/APN232.pdf`,
                    },
                ],
            },
            //Licitación N231
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N231-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en el municipio de Ixmiquilpan, en la localidad de Pueblo Nuevo en calle Principal; ubicada en la localidad de Pueblo Nuevo, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N231/N231.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N231/JAN231.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N231/APN231.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N231/FAN231.pdf`,
                    },
                ],
            },
            //Licitación N230
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N230-2023.',
                'vigencia': 'Vigencia de venta de bases: del 11 al 19 de septiembre.',
                'descripcionProcedimiento': 'Construcción del libramiento El Peral - Hacienda Hueyapan, municipio de Huasca de Ocampo, Hidalgo; ubicada en la localidad de San Juan Hueyapan, Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}24/N230/N230.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}24/N230/JAN230.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}24/N230/APN230.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}24/N230/FAN230.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 023/2023',
        'idConvocatoria': 'Convocatoria23',
        'procedimientos': [
            //Licitación N229
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N229-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de acceso principal al municipio de Xochiatipan.; ubicada en la localidad y Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N229/N229.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N229/JAN229.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N229/APN229.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N229/FAN229.pdf`,
                    },
                ],
            },
            //Licitación N228
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N228-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Chiapa, del Km 0+000 al Km 2+000; en el municipio de Xochiatipan.; ubicada en la localidad de Chiapa, Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N228/N228.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N228/JAN228.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N228/APN228.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N228/FAN228.pdf`,
                    },
                ],
            },
            //Licitación N227
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N227-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Acahuasco, del km 0+000 al km 6+000; en el municipio de Tlanchinol.; ubicada en la localidad de Acahuasco, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N227/N227.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N227/JAN227.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N227/APN227.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N227/FAN227.pdf`,
                    },
                ],
            },
            //Licitación N226
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N226-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Pahuatzintla - Nepalapa, del km 0+000 al km 2+000; en el municipio de Huejutla de Reyes; ubicada en la localidad de Pahuatzintla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N226/N226.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N226/JAN226.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N226/APN226.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N226/FAN226.pdf`,
                    },
                ],
            },
            //Licitación N225
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N225-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Huautla-El Cojolite) -Coatzonco, del km 0+000 al km 4+500; en el municipio de Huautla.; ubicada en la localidad de Coatzonco, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N225/N225.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N225/JAN225.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N225/FAN225.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N225/FAN225.pdf`,
                    },
                ],
            },
            //Licitación N224
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N224-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Huehuetla - Atappa - Octatitla, del km 0+000 al km 2+500; en el municipio de Huejutla de Reyes.; ubicada en la localidad de Atappa, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N224/N224.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N224/JAN224.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N224/APN224.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N224/FAN224.pdf`,
                    },
                ],
            },
            //Licitación N223
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N223-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Acatepec-Huemaco, del km 0+000 al km 2+830; en el municipio de Huautla.; ubicada en la localidad de Acatepec, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N223/N223.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N223/JAN223.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N223/APN223.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N223/FAN223.pdf`,
                    },
                ],
            },
            //Licitación N222
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N222-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 18 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Atlapexco-Huautla) - Xionaxtla, del km 0+000 al km 3+000; en el municipio de Huejutla.; ubicada en la localidad de Xionaxtla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N222/N222.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N222/JAN222.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N222/APN222.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N222/FAN222.pdf`,
                    },
                ],
            },
            //Licitación N221
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N221-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Acceso a Yahualica)-Pahactla -Santo Tomas-Xancaltitla, del km 0+000 al km 4+700; en el municipio de Atlapexco.; ubicada en la localidad de Pahactla, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N221/N221.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N221/JAN221.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N221/APN221.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N221/FAN221.pdf`,
                    },
                ],
            },
            //Licitación N220
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N220-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: E.C. (Huejutla-Atlapexco) -Ixtacuayo, del km 0+000 al km 2+000; en el municipio de Atlapexco.; ubicada en la localidad de Ixtacuayo, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N220/N220.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N220/JAN220.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N220/APN220.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N220/FAN220.pdf`,
                    },
                ],
            },
            //Licitación N219
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N219-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Tamalcuatitla - Tepehica, del km 0+000 al km 3+000; en el municipio de Huejutla de Reyes.; ubicada en la localidad de Tamalcuatitla, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N219/N219.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N219/JAN219.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N219/APN219.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N219/FAN219.pdf`,
                    },
                ],
            },
            //Licitación N218
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N218-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Construcción de pavimentación en calle Benito Juárez, en la localidad de Venustiano Carranza, en el municipio de Zempoala.; ubicada en la localidad de Venustiano Carranza, Municipio de Zempoala, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N218/N218.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N218/JAN218.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N218/APN218.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N218/FAN218.pdf`,
                    },
                ],
            },
            //Licitación N217
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N217-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Mercado Municipal 2ª. etapa en el municipio de Singuilucan.; ubicada en la localidad y Municipio de Singuilucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N217/N217.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N217/JAN217.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N217/APN217.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N217/FAN217.pdf`,
                    },
                ],
            },
            //Licitación N216
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N216-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del Corredor Industrial.; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N216/N216.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N216/JAN216.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N216/APN216.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N216/FAN216.pdf`,
                    },
                ],
            },
            //Licitación N215
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N215-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Asfáltica en Calle Guadalupe Col. 21 de Julio; en el municipio de Tepeapulco .; ubicada en la localidad de Fray Bernardino de Sahagún (Ciudad Sahagún), Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N215/N215.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N215/JAN215.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N215/APN215.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N215/FAN215.pdf`,
                    },
                ],
            },
            //Licitación N214
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N214-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 13 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo acceso a La Florida, del km 0+000 al km 6+000; en el municipio de Lolotla.; ubicada en la localidad de La Florida, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N214/N214.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N214/JAN214.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N214/APN214.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N214/FAN214.pdf`,
                    },
                ],
            },
            //Licitación N213
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N213-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Construcción de red de distribución de agua potable en "Aguaje" de Cerro Prieto, en el municipio de La Misión.; ubicada en la localidad de Aguaje de Cerro Prieto (Los Paredones), Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N213/N213.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N213/JAN213.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N213/APN213.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N213/FAN213.pdf`,
                    },

                ],
            },
            //Licitación N212
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N212-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Comontla - Ixtacuatla, del km 0+000 al km 4+500; en el municipio de Lolotla.; ubicada en la localidad de Comontla, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N212/N212.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N212/JAN212.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N212/APN212.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N212/FAN212.pdf`,
                    },
                ],
            },
            //Licitación N211
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N211-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica de Av. Victoria (Hombro B); en el municipio de Zempoala.; ubicada en la localidad de Privadas Santa Matilde, Municipio de Zempoala, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N211/N211.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N211/JAN211.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N211/APN211.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N211/FAN211.pdf`,
                    },
                ],
            },
            //Licitación N210
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N210-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica de Av. Victoria (Hombro A); en el municipio de Zempoala.; ubicada en la localidad de Privadas Santa Matilde, Municipio de Zempoala, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N210/N210.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N210/JAN210.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N210/APN210.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N210/FAN210.pdf`,
                    },
                ],
            },
            //Licitación N209
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N209-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Toctitlán, del km 0+000 al km 4+300 .; ubicada en la localidad de San Salvador, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N209/N209.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N209/JAN209.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N209/APN209.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N209/FAN209.pdf`,
                    },
                ],
            },
            //Licitación N208
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N208-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: San Salvador-Toctitlán, del km 0+000 al km 5+000.; ubicada en la localidad de San Salvador, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N208/N208.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N208/JAN208.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N208/APN208.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N208/FAN208.pdf`,
                    },
                ],
            },
            //Licitación N207
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N207-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en Ojo de Agua Santa Rosa, Manzana 1, municipio de El Arenal.; ubicada en la localidad de Ojo de Agua Santa Rosa, Municipio de El Arenal, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N207/N207.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N207/JAN207.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N207/APN207.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N207/FAN207.pdf`,
                    },
                ],
            },
            //Licitación N206
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N206-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Toctitlán - Tianguis, del Km 0+000 al Km 7+000.; ubicada en la localidad de Toctitlán, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N206/N206.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N206/JAN206.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N206/APN206.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N206/FAN206.pdf`,
                    },
                ],
            },
            //Licitación N205
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N205-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Chipoco del km 0+000 al km 1+500, en el municipio de Tlanchinol.; ubicada en la localidad de Chipoco, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N205/N205.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N205/JAN205.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N205/APN205.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N205/FAN205.pdf`,
                    },
                ],
            },
            //Licitación N204
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N204-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo San Miguel - Xaltipa - Lontla, del Km 0+000 al Km 7+000; en el municipio de Tlanchinol; ubicada en la localidad de San Miguel, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N204/N204.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N204/JAN204.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N204/APN204.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N204/FAN204.pdf`,
                    },
                ],
            },
            //Licitación N203
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N203-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación de tramo E.C. (Naranjos - Yatipan) - Aguacatitla, del Km 0+000 al Km 3+000.; ubicada en la localidad de Aguacatitla, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N203/N203.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N203/JAN203.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N203/APN203.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N203/FAN203.pdf`,
                    },
                ],
            },
            //Licitación N202
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N202-2023.',
                'vigencia': 'Vigencia de venta de bases: del 4 al 12 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Chompeletla - Zacayahual, del Km 0+000 al Km 2+600.; ubicada en la localidad de Chompeletla, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}23/N202/N202.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}23/N202/JAN202.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}23/N202/APN202.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}23/N202/FAN202.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 022/2023',
        'idConvocatoria': 'Convocatoria22',
        'procedimientos': [
            //Licitación N201
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N201-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación de Concreto Hidráulico en Barrio San Javier Zacacuautla; en el municipio de Acaxochitlán.; ubicada en la localidad de Zacacuautla, Municipio de Acaxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N201/N201.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N201/JAN201.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N201/APN201.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N201/FAN201.pdf`,
                    },
                ],
            },
            //Licitación N200
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N200-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de la carretera Huichapan - San José Atlán, en el municipio de Huichapan.; ubicada en la localidad de San José Atlán, Municipio de Huichapan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N200/N200.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N200/JAN200.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N200/APN200.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N200/FAN200.pdf`,
                    },
                ],
            },
            //Licitación N199
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N199-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Casetas - Otongo) - Amoxco, del Km 0+000 al Km 14+500.; ubicada en la localidad de Amoxco, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N199/N199.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N199/JAN199.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N199/APN199.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N199/FAN199.pdf`,
                    },
                ],
            },
            //Licitación N198
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N198-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Tianguistengo - Lolotla - Atlapexco - Zoquitipan - Naranjos - Yatipan, del Km 0+000 al Km 10+000; ubicada en la localidad de Los Naranjos, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N198/N198.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N198/JAN198.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N198/APN198.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N198/FAN198.pdf`,
                    },
                ],
            },
            //Licitación N197
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N197-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Estabilidad de taludes de la Secretaría de Seguridad Pública de Hidalgo en Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N197/N197.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N197/JAN197.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N197/FAN197.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N197/FAN197.pdf`,
                    },
                ],
            },
            //Licitación N196
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N196-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Construcción de red de agua potable y cisternas para el CERESO de Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N196/N196.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N196/JAN196.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N196/APN196.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N196/FAN196.pdf`,
                    },
                ],
            },
            //Licitación N195
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N195-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Mejoramiento de la base de operaciones mixtas de la Secretaría de Seguridad Pública, en Tulancingo de Bravo, Hgo.; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N195/N195.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N195/JAN195.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones 2da.',
                        'urlresultado': `${ligabase}22/N195/JA2N195.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N195/APN195.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N195/FAN195.pdf`,
                    },
                ],
            },
            //Licitación N194
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N194-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Impermeabilización De losa de techo de la Secretaría de Seguridad Pública de Hidalgo, en Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N194/N194.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N194/JAN194.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N194/APN194.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N194/FAN194.pdf`,
                    },
                ],
            },
            //Licitación N193
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N193-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Construcción de dormitorios CERESO Pachuca de Soto Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N193/N193.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N193/JAN193.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N193/APN193.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N193/FAN193.pdf`,
                    },
                ],
            },
            //Licitación N192
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N192-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Construcción de dormitorios Cereso Módulo 2, Pachuca de Soto, Hgo.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N192/N192.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N192/JAN192.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N192/APN192.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N192/FAN192.pdf`,
                    },
                ],
            },
            //Licitación N191
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N191-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Mejoramiento de la base de operaciones mixtas de la Secretaría de Seguridad Pública de Hidalgo, en Mixquiahuala de Juárez, Hgo.; ubicada en la localidad y Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N191/N191.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N191/JAN191.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N191/APN191.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N191/FAN191.pdf`,
                    },
                ],
            },
            //Licitación N190
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N190-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Cuartel de Policía en Col. Cubitos, Pachuca de Soto, Hgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N190/N190.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N190/JAN190.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones 2da.',
                        'urlresultado': `${ligabase}22/N190/JA2N190.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N190/APN190.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N190/FAN190.pdf`,
                    },
                ],
            },
            //Licitación N189
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N189-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Construcción de polideportivo y mejoramiento de campo de tiro en el IFP de Mineral de la Reforma; ubicada en la localidad de San José Palma Gorda, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N189/N189.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N189/JAN189.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N189/APN189.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N189/FAN189.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}22/N189/AMDFAN189.pdf`,
                    },
                ],
            },
            //Licitación N188
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N188-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Mantenimiento correctivo de impermeabilización en Palacio de Gobierno del Estado de Hidalgo Pachuca de Soto Hgo.; de Cobertura Estatal.',
                'urlAnexos': `${ligabase}22/N188/N188.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N188/JAN188.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N188/APN188.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N188/FAN188.pdf`,
                    },
                ],
            },
            //Licitación N187
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N187-2023.',
                'vigencia': 'Vigencia de venta de bases: del 28 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación de pintura de puertas, rejas, ventanas y muros interiores y exteriores del inmueble de la Plaza de Toros Monumental Vicente Segura, de la Ciudad de Pachuca de Soto, Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}22/N187/N187.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}22/N187/JAN187.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}22/N187/APN187.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}22/N187/FAN187.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}22/N187/AMDFAN187.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 021/2023',
        'idConvocatoria': 'Convocatoria21',
        'procedimientos': [
            //Licitación N186
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N186-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Polígono de movilidad sustentable; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N186/N186.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N186/JAN186.pdf`,
                    },
                ],
            },
            //Licitación N185
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N185-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación de luminarias en el DESCTI.; de Cobertura Estatal.',
                'urlAnexos': `${ligabase}21/N185/N185.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N185/JAN185.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N185/APN185.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N185/FAN185.pdf`,
                    },
                ],
            },
            //Licitación N184
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N184-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica tramo Atlalco - Santa Teresa, en el municipio de Yahualica.; ubicada en la localidad de Santa Teresa, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N184/N184.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N184/JAN184.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N184/APN184.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N184/FAN184.pdf`,
                    },],
            },
            //Licitación N183
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N183-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación C.R. Santa María Temaxcalapa - Cerro Chiquito.; ubicada en la localidad de Santa María Temaxcalapa, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N183/N183.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N183/JAN183.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N183/APN183.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N183/FAN183.pdf`,
                    },
                ],
            },
            //Licitación N182
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N182-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Tecoluco Calpan-Metlatepec, del km 0+000 al km 1+500; en el  municipio de Huautla; ubicada en la localidad de Tecoluco Calpan, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N182/N182.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N182/JAN182.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N182/FAN182.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N182/FAN182.pdf`,
                    },
                ],
            },
            //Licitación N181
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N181-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación de pavimento asfáltico de la avenida Juárez, tramo: Blvd. Las Torres hacia E.C Libramiento Club Rotario, en el municipio de Tizayuca.; ubicada en la localidad y Municipio de Tizayuca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N181/N181.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N181/JAN181.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N181/APN181.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N181/FAN181.pdf`,
                    },
                ],
            },
            //Licitación N180
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N180-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación de Concreto Hidráulico del Camino Tlaxcantitla - Santa María; en el municipio de Tlahuiltepa.; ubicada en la localidad de Tlaxcantitla, Municipio de Tlahuiltepa, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N180/N180.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N180/JAN180.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N180/APN180.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N180/FAN180.pdf`,
                    },
                ],
            },
            //Licitación N179
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N179-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: Tetzahapa I-Temaxcaltitla-Coamila, del km cero al cinco punto cinco, en el municipio de Huejutla de Reyes.; ubicada en la localidad de Tetzahapa I, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N179/N179.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N179/JAN179.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N179/APN179.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N179/FAN179.pdf`,
                    },
                ],
            },
            //Licitación N178
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N178-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Teyahuala - Coyutla, del Km 0+000 al Km 3+000; en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Teyahuala, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N178/N178.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N178/JAN178.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N178/APN178.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N178/FAN178.pdf`,
                    },
                ],
            },
            //Licitación N177
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N177-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 5 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Atlalco - Tepehixpa - Xochitl, del Km 0+000 al Km 3+300; en el municipio de Yahualica.; ubicada en la localidad de Atlalco, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N177/N177.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N177/JAN177.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N177/APN177.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N177/FAN177.pdf`,
                    },
                ],
            },
            //Licitación N176
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N176-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Orizatlán - San José) - Rancho Nuevo, del km 0+000 al km 2+000; en el municipio de Tlanchinol.; ubicada en la localidad de Rancho Nuevo, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N176/N176.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N176/JAN176.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N176/APN176.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N176/FAN176.pdf`,
                    },
                ],
            },
            //Licitación N175
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N175-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Concreto hidráulico en Tecozautla calle Gardenia; ubicada en la localidad y Municipio de Tecozautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N175/N175.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N175/JAN175.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N175/APN175.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N175/FAN175.pdf`,
                    },
                ],
            },
            //Licitación N174
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N174-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico y construcción de línea de alcantarillado sanitario, en calle de Acceso al Banco Bienestar, en el municipio de Tezontepec de Aldama; ubicada en la localidad de Presas, Municipio de Tezontepec de Aldama, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N174/N174.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N174/JAN174.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N174/APN174.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N174/FAN174.pdf`,
                    },
                ],
            },
            //Licitación N173
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N173-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación hidráulica en calle Galo, en la localidad Gral. Pedro María Anaya, municipio de Tepetitlán.; ubicada en la localidad de General Pedro María Anaya, Municipio de Tepetitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N173/N173.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N173/JAN173.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N173/APN173.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N173/FAN173.pdf`,
                    },
                ],
            },
            //Licitación N172
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N172-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Red de Drenaje Sanitario en Calle Francisco Villa, Col. el Venado, en el Municipio de Mineral de la Reforma; ubicada en la localidad de El Venado, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N172/N172.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N172/JAN172.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N172/APN172.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N172/FAN172.pdf`,
                    },
                ],
            },
            //Licitación N171
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N171-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Construcción de red de agua potable en calle Francisco Villa, col. El Venado, en el municipio de Mineral de la Reforma.; ubicada en la localidad de El Venado, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N171/N171.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N171/JAN171.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N171/APN171.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N171/FAN171.pdf`,
                    },
                ],
            },
            //Licitación N170
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N170-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Construcción de obra de toma, línea de conducción del Canal de Interconexión de la Presa de  Almacenamiento "El Yathé" al Canal Principal Vicente Aguirre del Km 0+046.26 al Km 0+623.30, en el municipio de Alfajayucan.; ubicada en la localidad y Municipio de Alfajayucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N170/N170.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N170/JAN170.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N170/APN170.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N170/FAN170.pdf`,
                    },
                ],
            },
            //Licitación N169
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N169-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Atlalco - Xochitl) - Chiatitla, del Km 0+000 al Km 2+000, en el municipio de Yahualica.; ubicada en la localidad de Chiatitla, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N169/N169.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N169/JAN169.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N169/APN169.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N169/FAN169.pdf`,
                    },
                ],
            },
            //Licitación N168
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N168-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Xuchitlan) - Jalpa, del Km 0+000 al Km 6+000; en el municipio de Tlanchinol.; ubicada en la localidad de Jalpa, Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N168/N168.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N168/JAN168.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N168/APN168.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N168/FAN168.pdf`,
                    },
                ],
            },
            //Licitación N167
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N167-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Tres Huastecas - Tamalcuatitla, del km 0+000 al km 3+000; en el municipio de Yahualica.; ubicada en la localidad de Tamalcuatitla, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N167/N167.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N167/JAN167.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N167/APN167.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N167/FAN167.pdf`,
                    },
                ],
            },
            //Licitación N166
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N166-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo de acceso a Chompeletla, del Km 0+000 al Km 2+000; ubicada en la localidad de Chompeletla, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N166/N166.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N166/JAN166.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N166/APN166.pdf`,
                    },
                ],
            },
            //Licitación N165
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N165-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Construcción del Distribuidor Vial Entronque Carretera Federal Tuxpan - Jaltepec, en el Municipio de Tulancingo de Bravo.; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N164/N164.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N165/JAN165.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones 2da.',
                        'urlresultado': `${ligabase}21/N165/JA2N165.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N165/APN165.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N164/FAN164.pdf`,
                    },
                ],
            },
            //Licitación N164
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N164-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación Asfáltica de Calle Principal San Isidro en la Localidad El Boxtha, en el Municipio de Actopan.; ubicada en la localidad de El Boxtha, Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N164/N164.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N164/JAN164.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N164/APN164.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N164/FAN164.pdf`,
                    },
                ],
            },
            //Licitación N163
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N163-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Asfáltica en Chapantongo, en la Localidad de Juchitlan.; ubicada en la localidad de Juchitlán, Municipio de Chapantongo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N163/N163.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N163/JAN163.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N163/APN163.pdf`,
                    },
                ],
            },
            //Licitación N162
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N162-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de la calle 15 de Septiembre, en la localidad de Remedios, Ixmiquilpan.; ubicada en la localidad de Los Remedios, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N162/N162.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N162/JAN162.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N162/APN162.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N162/FAN162.pdf`,
                    },
                ],
            },
            //Licitación N161
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N161-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Apan - La Unión (Limites con el Estado de Tlaxcala).; ubicada en la localidad y Municipio de Apan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N161/N161.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N161/JAN161.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N161/APN161.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N161/FAN161.pdf`,
                    },
                ],
            },
            //Licitación N160
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N160-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Tecamatl (San Agustin Tlaxiaca) - Ajacuba.; ubicada en la localidad de Tecamatl, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N160/N160.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N160/JAN160.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N160/APN160.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N160/FAN160.pdf`,
                    },
                ],
            },
            //Licitación N159
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N159-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del tramo del Chabacano-La Conchita del Km 0+000 al Km 1+495; ubicada en la localidad de La Conchita (La Cantera), Municipio de Singuilucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N159/N159.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N159/JAN159.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N159/APN159.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N159/FAN159.pdf`,
                    },
                ],
            },
            //Licitación N158
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N158-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación Hidráulica en la Calle 8 en la Colonia Parque de Poblamiento, en el Municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N158/N158.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N158/JAN158.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N158/APN158.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N158/FAN158.pdf`,
                    },
                ],
            },
            //Licitación N157
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N157-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 4 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación Hidráulica en la Calle Andador 1-A Manzana M en el Fraccionamiento Plutarco Elías Calles, en el Municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N157/N157.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N157/JAN157.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N157/APN157.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N157/FAN157.pdf`,
                    },
                ],
            },
            //Licitación N156
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N156-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': '"Pavimentación Hidráulica en acceso principal Boxaxni - Santa Mónica el Sitio (Segunda Etapa) .; ubicada en Varias localidades del Municipio de Santiago de Anaya, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N156/N156.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N156/JAN156.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N156/APN156.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N156/FAN156.pdf`,
                    },
                ],
            },
            //Licitación N155
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N155-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Reconstrucción del camino Gandhó - Rancho Viejo - El Geiser - La Salitrera - Uxdejhe (Estatal 101) del Km 0+000 Al Km 4+000, en el municipio Tecozautla.; ubicada en Varias localidades del Municipio de Tecozautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N155/N155.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N155/JAN155.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N155/APN155.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N155/FAN155.pdf`,
                    },
                ],
            },
            //Licitación N154
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N154-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica en Calle Temazola, en el municipio de Metztitlán.; ubicada en Varias localidades del Municipio de Metztitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N154/N154.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N154/JAN154.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N154/APN154.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N154/FAN154.pdf`,
                    },
                ],
            },
            //Licitación N153
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N153-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación de la carretera paso por Ixmiquilpan.; ubicada en Varias localidades del Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N153/N153.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N153/JAN153.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N153/APN153.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N153/FAN153.pdf`,
                    },


                ],
            },
            //Licitación N152
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N152-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación de la C.E. Tula de Allende - Tepetitlán, en el municipio de Tepetitlán.; ubicada en la localidad de General Pedro María Anaya, Municipio de Tepetitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N152/N152.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N152/JAN152.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N152/APN152.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N152/FAN152.pdf`,
                    },
                ],
            },
            //Licitación N151
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N151-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Construcción de la línea de conducción de agua potable del pozo San Pedro Huatengo al tanque elevado existente en la colonia Satélites, en el municipio de Santiago Tulantepec en la localidad de San Pedro Huatengo.; ubicada en la localidad de San Pedro Huatengo, Municipio de Santiago Tulantepec de Lugo Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N151/N151.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N151/JAN151.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N151/APN151.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N151/FAN151.pdf`,
                    },
                ],
            },
            //Licitación N150
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N150-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Construcción de red de distribución de agua potable en Cerro Prieto en el municipio de La Misión; ubicada en la localidad de Cerro Prieto, Municipio de La Misión, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N150/N150.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N150/JAN150.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N150/APN150.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N150/FAN150.pdf`,
                    },
                ],
            },
            //Licitación N149
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N149-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Ixtlapalaco - Cahuazas, del Km 0+000 al Km 7+000; en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Ixtlapalaco, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N149/N149.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N149/JAN149.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N149/APN149.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N149/FAN149.pdf`,
                    },
                ],
            },
            //Licitación N148
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N148-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Pavimentación de Concreto Hidráulico en la Calle Principal del Centro, en la Localidad Santa Ana Tzacuala, en el Municipio de Acaxochitlan.; ubicada en la localidad de Santa Ana Tzacuala, Municipio de Acaxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N148/N148.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N148/JAN148.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N148/APN148.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N148/FAN148.pdf`,
                    },
                ],
            },
            //Licitación N147
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N147-2023.',
                'vigencia': 'Vigencia de venta de bases: del 21 de agosto al 1 de septiembre.',
                'descripcionProcedimiento': 'Construcción de pavimento de concreto hidráulico en Calle Valle de Cerato, en el municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}21/N147/N147.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}21/N147/JAN147.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}21/N147/APN147.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}21/N147/FAN147.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 020/2023',
        'idConvocatoria': 'Convocatoria20',
        'procedimientos': [
            //Licitación N146
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N146-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación de concreto hidráulico en Cerrada del Pípila en el Barrio Santa Cruz 2da Sección, en el municipio de Molango de Escamilla.; ubicada en la localidad y Municipio de Molango de Escamilla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N146/N146.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N146/JAN146.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N146/APN146.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N146/FAN146.pdf`,
                    },
                ],
            },
            //Licitación N145
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N145-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Pavimentación del Camino Rural E.C.F. Acatempa - San Salvador -Tianguis - Tlalnepanco - Tehuetlan, en el Municipio de Tlanchinol.; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N145/N145.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N145/JAN145.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N145/APN145.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N145/FAN145.pdf`,
                    },
                ],
            },
            //Licitación N144
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N144-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la Autopista Turística de la Montaña (Cuerpo A); ubicada en la localidad de San Guíllermo la Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N144/N144.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N144/JAN144.pdf`,
                    },
                ],
            },
            //Licitación N143
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N143-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción del Boulevard de Acceso al Huixmi, en el Municipio de Pachuca de Soto.; ubicada en la localidad de El Huixmí, Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N143/N143.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N143/JAN143.pdf`,
                    },
                ],
            },
            //Licitación N142
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N142-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico de la Calle Juan Escutia (tramo entre las calles Tomás Urbina y 21 de Marzo).; ubicada en la localidad de Tezontepec, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N142/N142.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N142/JAN142.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N142/APN142.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N142/FAN142.pdf`,
                    },
                ],
            },
            //Licitación N141
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N141-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de banquetas y guarniciones en camino Acalome- Pilas y Granadas en el municipio de Metztitlan.; ubicada en la localidad de Pilas y Granadas, Municipio de Metztitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N141/N141.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N141/JAN141.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}20/N141/AMDJAN141.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N141/APN141.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N141/FAN141.pdf`,
                    },
                ],
            },
            //Licitación N140
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N140-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de Pavimento de Concreto Hidráulico en Calle Alfonso Corona del Rosal, en el Municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N140/N140.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N140/JAN140.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N140/APN140.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N140/FAN140.pdf`,
                    },
                ],
            },
            //Licitación N139
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N139-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Pavimentación hidráulica en la calle 9 en la Colonia Parque de Poblamiento, en el Municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N139/N139.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N139/JAN139.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N139/APN139.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N139/FAN139.pdf`,
                    },
                ],
            },
            //Licitación N138
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N138-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimento de concreto hidráulico, banquetas y guarniciones en las Calles Campo de Tiro y Alfonso Corona del Rosal, en el Municipio de Pachuca.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N138/N138.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N138/JAN138.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N138/APN138.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N138/FAN138.pdf`,
                    },


                ],
            },
            //Licitación N137
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N137-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de drenaje pluvial (alcantarilla tipo bóveda) en Camino de Acceso Principal a la localidad El Piñal, San Bartolo Tutotepec.; ubicada en la localidad de El Piñal, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N137/N137.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N137/JAN137.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N137/APN137.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N137/FAN137.pdf`,
                    },
                ],
            },
            //Licitación N136
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N136-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Construcción de Pavimentación Hidráulica en la Localidad de Achiquihuxtla en Barrio Achiquihuxtla I, Calle La Curva, en el Municipio de Atlapexco.; ubicada en la localidad de Achiquihuixtla, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N136/N136.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N136/JAN136.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N136/APN136.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N136/FAN136.pdf`,
                    },
                ],
            },
            //Licitación N135
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N135-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación de la C.E. Metepec-Tenango de Doria.; ubicada en la localidad y Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N135/N135.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N135/JAN135.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N135/APN135.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N135/FAN135.pdf`,
                    },
                ],
            },
            //Licitación N134
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N134-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Construcción de Huellas de Concreto del C.R. Las Piletas-Bandola, en el Municipio de Mineral del Chico; ubicada en la localidad de Las Piletas, Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N134/N134.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N134/JAN134.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N134/APN134.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N134/FAN134.pdf`,
                    },
                ],
            },
            //Licitación N133
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N133-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Tenango de Doria al Desdavi.; ubicada en la localidad de El Desdavi, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N133/N133.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N133/JAN133.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N133/APN133.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N133/FAN133.pdf`,
                    },
                ],
            },
            //Licitación N132
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N132-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Enzuelado - Carpinteros (Segunda Etapa); ubicada en la localidad de Carpinteros, Municipio de San Agustín Metzquititlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N132/N132.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N132/JAN132.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N132/APN132.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N132/FAN132.pdf`,
                    },
                ],
            },
            //Licitación N131
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N131-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Modernización del Camino Eloxochitlán - Molango, en el municipio de Eloxochitlán.; ubicada en la localidad y Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N131/N131.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N131/JAN131.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N131/APN131.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N131/FAN131.pdf`,
                    },
                ],
            },
            //Licitación N130
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N130-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Modernización y Ampliación del C.R. Pozuelos - El Palmar; Tramo del km 0+000 al 12+209, Subtramo: del km 0+000 al 6+763.21, en el Municipio de Cardonal.; ubicada en la localidad de Pozuelos, Municipio de Cardonal, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N130/N130.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N130/JAN130.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N130/APN130.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N130/FAN130.pdf`,
                    },
                ],
            },
            //Licitación N129
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N129-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Modernización de camino de acceso a Tilcuautla, en los municipios de Pachuca de Soto y San  Agustín Tlaxiaca.; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N129/N129.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N129/JAN129.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N129/APN129.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N129/FAN129.pdf`,
                    },
                ],
            },
            //Licitación N128
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N128-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación de Carpeta Asfáltica en el Blvd. Everardo Márquez, en la Colonia Periodistas, en el Municipio de Pachuca; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N128/N128.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N128/JAN128.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N128/APN128.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N128/FAN128.pdf`,
                    },
                ],
            },
            //Licitación N127
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N127-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 21 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Piedra Hincada - Las Piedras, en el Municipio de San Felipe Orizatlán.; ubicada en la localidad y Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N127/N127.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N127/JAN127.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N127/APN127.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N127/FAN127.pdf`,
                    },
                ],
            },
            //Licitación N126
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N126-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Metztitlán - Eloxochitlán.; ubicada en la localidad y Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N126/N126.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N126/JAN126.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N126/APN126.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N126/FAN126.pdf`,
                    },
                ],
            },
            //Licitación N125
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N125-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación de Carpeta Asfáltica en la Calle Felipe Angeles, en la Colonia Periodistas, en el Municipio de Pachuca..; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N125/N125.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N125/JAN125.pdf`,
                    },
                ],
            },
            //Licitación N124
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N124-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Desdavi a Santa María Temaxcalapa.; ubicada en la localidad de Santa María Temaxcalapa, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N124/N124.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N124/JAN124.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N124/APN124.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N124/FAN124.pdf`,
                    },
                ],
            },
            //Licitación N123
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N123-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción C.E. Santa María Temaxcalapa - San Bartolo Tutotepec.; ubicada en la localidad de Calintla, Municipio de San Bartolo Tutotepec, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N123/N123.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N123/JAN123.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N123/APN123.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N123/FAN123.pdf`,
                    },
                ],
            },
            //Licitación N122
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N122-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación de la Red de distribución de agua potable de la cabecera municipal de Zacualtipán.; ubicada en la localidad de Zacualtipan, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N122/N122.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N122/JAN122.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N122/APN122.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N122/FAN122.pdf`,
                    },
                ],
            },
            //Licitación N121
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N121-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la Autopista Turística de la Montaña (Cuerpo B).; ubicada en la localidad de San Guillermo La Reforma, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N121/N121.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N121/JAN121.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}20/N121/AMDJAN121.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N121/APN121.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}20/N121/AMDAPN121.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N121/FAN121.pdf`,
                    },
                ],
            },
            //Licitación N120
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N120-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Construcción de sistema de alcantarillado sanitario en la localidad de El Aguacate, en el municipio de Nicolás Flores; ubicada en la localidad de El Aguacate, Municipio de Nicolás Flores, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N120/N120.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N120/JAN120.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N120/APN120.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N120/FAN120.pdf`,
                    },
                ],
            },
            //Licitación N119
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N119-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Pavimentación de acceso a la Universidad Benito Juárez, Plantel Tlanchinol; ubicada en la localidad y Municipio de Tlanchinol, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N119/N119.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N119/JAN119.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N119/APN119.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N119/FAN119.pdf`,
                    },
                ],
            },
            //Licitación N118
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N118-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Pavimentación integral en calle Matamoros sur entre calle Melchor Ocampo y Av. Matamoros; ubicada en la localidad de Acayuca, Municipio de Zapotlán de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N118/N118.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N118/JAN118.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N118/APN118.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N118/FAN118.pdf`,
                    },
                ],
            },
            //Licitación N117
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N117-2023.',
                'vigencia': 'Vigencia de venta de bases: del 14 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: Tamoyón II-Pepeyoca de Cabrera, del km 0+000 al km 10+000.; ubicada en la localidad de Tamoyón II, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}20/N117/N117.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}20/N117/JAN117.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}20/N117/APN117.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}20/N117/FAN117.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 019/2023',
        'idConvocatoria': 'Convocatoria19',
        'procedimientos': [
            //Licitación N116
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N116-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: acceso a Huemaco, del km 0+000 al km 8+000; ubicada en la localidad y Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N116/N116.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N116/JAN116.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N116/APN116.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N116/FAN116.pdf`,
                    },
                ],
            },
            //Licitación N115
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N115-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: Pepeyoca de Cabrera-Ahuatitla, del km 0+000 al km 3+500; ubicada en la localidad de Pepeyoca de Cabrera, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N115/N115.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N115/JAN115.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N115/APN115.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N115/FAN115.pdf`,
                    },
                ],
            },
            //Licitación N114
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N114-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: E.C. Atlapexco-Cuatapa-Tenexco, del km 0+000 al km 3+900.; ubicada en la localidad de Cuatapa, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N114/N114.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N114/JAN114.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N114/APN114.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N114/FAN114.pdf`,
                    },
                ],
            },
            //Licitación N113
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N113-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Pavimentación del tramo carretero San Pablo El Grande, entronque a San Nicolás; ubicada en la localidad de San Nicolás, Municipio de Tenango de Doria, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N113/N113.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N113/JAN113.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N113/APN113.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N113/FAN113.pdf`,
                    },
                ],
            },
            //Licitación N112
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N112-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. San Felipe  Orizatlán Huejutla de Reyes Huichapa La Corrala Santa Cruz, del km 0+000 al km 3+000 en el municipio de Huejutla de Reyes; ubicada en la localidad de  La Corrala, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N112/N112.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N112/JAN112.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N112/APN112.pdf`,
                    },
                ],
            },
            //Licitación N111
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N111-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del Tramo Xiliapa-Acoyotla, del km 0+000 al km 6+000; en el municipio de Tehuacán de Guerrero; ubicada en la localidad de Xiliapa, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N111/N111.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N111/JAN111.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N111/APN111.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N111/FAN111.pdf`,
                    },
                ],
            },
            //Licitación N110
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N110-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo E.C. (Pachuca-Huejutla) Tlaltepingo, del Km 0+000 al Km 5+000; en el municipio de Lolotla; ubicada en la localidad de Tlaltepingo, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N110/N110.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N110/JAN110.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N110/APN110.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N110/FAN110.pdf`,
                    },
                ],
            },
            //Licitación N109
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N109-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: Nexpa-Monte Grande, del km 0+000 al km 12+700, en el municipio de San Felipe Orizatlán.; ubicada en la localidad de NEXPA, Municipio de San Felipe Orizatlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N109/N109.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N109/JAN109.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N109/APN109.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N109/FAN109.pdf`,
                    },
                ],
            },
            //Licitación N108
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N108-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Atlalco- El Paraje, del km 0+000 al km 1+000; ubicada en la localidad de Atlalco, Municipio de Yahualica, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N108/N108.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N108/JAN108.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N108/APN108.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N108/FAN108.pdf`,
                    },
                ],
            },
            //Licitación N107
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N107-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 22 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en acceso a Dexha en el municipio de Chapantongo; ubicada en la localidad de Dexha, Municipio de Chapantongo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N107/N107.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N107/JAN107.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N107/APN107.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N107/FAN107.pdf`,
                    },
                ],
            },
            //Licitación N106
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N106-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Construcción de concreto hidráulico en acceso a cabecera municipal de Chapantongo; ubicada en la localidad y Municipio de Chapantongo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N106/N106.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N106/JAN106.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}19/N106/AMDJAN106.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N106/APN106.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N106/FAN106.pdf`,
                    },
                ],
            },
            //Licitación N105
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N105-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de camino rural San Nicolás-Coatzontla, en el municipio de Juárez Hidalgo; ubicada en la localidad de San Nicolás Coatzontla, Municipio de Juárez Hidalgo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N105/N105.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N105/JAN105.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N105/APN105.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N105/FAN105.pdf`,
                    },
                ],
            },
            //Licitación N104
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N104-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en calle Agustín Olvera del municipio de Acatlán, Hidalgo; ubicada en la localidad de Agustín Olvera Sección  (colonia), Municipio de Acatlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N104/N104.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N104/JAN104.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N104/APN104.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N104/FAN104.pdf`,
                    },
                ],
            },
            //Licitación N103
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N103-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en la calle Ana Lamanche, en el municipio de Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N103/N103.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N103/JAN103.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N103/APN103.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N103/FAN103.pdf`,
                    },
                ],
            },
            //Licitación N102
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N102-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica a el panteón, El Meje, municipio de El Arenal; ubicada en la localidad de El Meje, Municipio de El Arenal, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N102/N102.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N102/JAN102.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N102/APN102.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N102/FAN102.pdf`,
                    },
                ],
            },
            //Licitación N101
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N101-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de la carretera San Andrés - Tecpaco - Tecueyaca; ubicada en la localidad de Tecpaco, Municipio de Calnali, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N101/N101.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N101/JAN101.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N101/APN101.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N101/FAN101.pdf`,
                    },
                ],
            },
            //Licitación N100
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N100-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: E.C. Cuatapa - Tenexco - Tlahica, del km 0+000 al km 0+500; ubicada en la localidad de Tlahica, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N100/N100.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N100/JAN100.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N100/APN100.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N100/FAN100.pdf`,
                    },
                ],
            },
            //Licitación N99
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N99-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 21 de agosto.',
                'descripcionProcedimiento': 'Pavimentación con concreto hidráulico de calle Brillante, entre Av. Minerales y calle Diamante en la localidad de Santa María la Calera en el municipio de Mineral de la Reforma; ubicada en la localidad de Santa María la Calera, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N99/N99.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N99/JAN99.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N99/APN99.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N99/FAN99.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}19/N99/AMDFAN99.pdf`,
                    },
                ],
            },
            //Licitación N98
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N98-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en calle Sonora y Morelos en la localidad de El Tepeyac, municipio de Cuautepec de Hinojosa; ubicada en la localidad de El Tepeyac, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N98/N98.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N98/JAN98.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N98/APN98.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N98/FAN98.pdf`,
                    },
                ],
            },
            //Licitación N97
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N97-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a La Reforma, del Km 0+000 al Km 4+000; en el municipio de Tepehuacán de Guerrero; ubicada en la localidad de La Reforma, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N97/N97.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N97/JAN97.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N97/APN97.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N97/FAN97.pdf`,
                    },
                ],
            },
            //Licitación N96
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N96-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica en Lázaro Cárdenas; ubicada en la localidad de Conejos, Municipio de Atotonilco de Tula, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N96/N96.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N96/JAN96.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N96/APN96.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N96/FAN96.pdf`,
                    },
                ],
            },
            //Licitación N95
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N95-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Modernización del camino El Rayo en el municipio de Pisaflores; ubicada en la localidad y Municipio de Pisaflores, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N95/N95.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N95/JAN95.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N95/APN95.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N95/FAN95.pdf`,
                    },
                ],
            },
            //Licitación N94
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N94-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en la calle de acceso al IMSS, Subdelegación Tulancingo, en el municipio de Tulancingo; ubicada en la localidad de Santa maría el Chico, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N94/N94.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N94/JAN94.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N94/APN94.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N94/FAN94.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}19/N94/AMDFAN94.pdf`,
                    },
                ],
            },
            //Licitación N93
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N93-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Zacualtipanito, del Km 0+000 al Km 4+000; en el municipio de Tepehuacán de Guerrero; ubicada en la localidad de Zacualtipanito, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N93/N93.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N93/JAN93.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N93/APN93.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N93/FAN93.pdf`,
                    },
                ],
            },
            //Licitación N92
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N92-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Tizapa, del km 0+000 al km 5+500; en el municipio de Tepehuacán de Guerrero; ubicada en la localidad de Tizapa, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N92/N92.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N92/JAN92.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N92/APN92.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N92/FAN92.pdf`,
                    },
                ],
            },
            //Licitación N91
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N91-2023.',
                'vigencia': 'Vigencia de venta de bases: del 7 al 18 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo Tenango - Ahuatetla, del km 0+000 al km 7+300; en el municipio de Tepehuacán de Guerrero; ubicada en la localidad de Tenango, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}19/N91/N91.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}19/N91/JAN91.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}19/N91/APN91.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}19/N91/FAN91.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 018/2023',
        'idConvocatoria': 'Convocatoria18',
        'procedimientos': [
            //Licitación N90
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N90-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 8 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en municipio de San Salvador, localidad El Tablón, camino por el canal; ubicada en la localidad de El Tablón, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N90/N90.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N90/JAN90.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N90/APN90.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N90/FAN90.pdf`,
                    },
                ],
            },
            //Licitación N89
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N89-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 8 de agosto.',
                'descripcionProcedimiento': 'Construcción de huellas de concreto hidráulico y empedrado en el municipio de Zimapán, en la localidad de Plutarco Elías Calles, Manzana Tlalpan, calle Granada y Durazno; ubicada en la localidad de Plutarco Elías Calles (Santiago), Municipio de Zimapán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N89/N89.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N89/JAN89.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N89/APN89.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N89/FAN89.pdf`,
                    },
                ],
            },
            //Licitación N88
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N88-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 8 de agosto.',
                'descripcionProcedimiento': 'Construcción de huellas de concreto hidráulico y empedrado en el municipio de Zimapán, en la localidad de Plutarco Elías Calles, Manzana las Lindas en calle Ciprés; ubicada en la localidad de Plutarco Elías Calles (Santiago), Municipio de Zimapán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N88/N88.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N88/JAN88.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N88/APN88.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N88/FAN88.pdf`,
                    },
                ],
            },
            //Licitación N87
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N87-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 8 de agosto.',
                'descripcionProcedimiento': 'Construcción de muros de contención en el camino rural Pisaflores - El Nogal - La Minita, municipio de Pisaflores; ubicada en Varias localidades del Municipio de Pisaflores, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N87/N87.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N87/JAN87.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N87/APN87.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N87/FAN87.pdf`,
                    },
                ],
            },
            //Licitación N86
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N86-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 8 de agosto.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en rodadas del camino a Cebadas, municipio de Mineral del Chico; ubicada en la localidad de Los Naranjos, Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N86/N86.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N86/JAN86.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N86/FAN86.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N86/FAN86.pdf`,
                    },
                ],
            },
            //Licitación N85
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N85-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico en rodadas del camino Naranjos - Tezahuapan, municipio de Mineral del Chico; ubicada en la localidad de Los Naranjos, Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N85/N85.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N85/JAN85.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N85/APN85.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N85/FAN85.pdf`,
                    },
                ],
            },
            //Licitación N84
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N84-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle del Moral entre Río y calle Bugambilia, col. El Paraíso, municipio de Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N84/N84.rar`,
                'resultados': [

                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N84/JAN84.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N84/APN84.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N84/FAN84.pdf`,
                    },],
            },
            //Licitación N83
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N83-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Construcción de empedrado Av. de Las Rosas, municipio de San Agustín Tlaxiaca; ubicada en la localidad de Casa Grande (Barrio), Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N83/N83.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N83/JAN83.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N83/APN83.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N83/FAN83.pdf`,
                    },
                ],
            },
            //Licitación N82
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N82-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de la calle Sur 2, Fraccionamiento Magisterio, entre calle Oriente 1 y calle Puerto Ángel, en el municipio de Mineral de la Reforma; ubicada en la localidad de Magisterio Digno, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N82/N82.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N82/JAN82.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N82/APN82.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N82/FAN82.pdf`,
                    },
                ],
            },
            //Licitación N81
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N81-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Pavimentación hidráulica de calle Venustiano Carranza (entre División del Norte y Miguel Hidalgo); ubicada en la localidad de Benito Juárez, Municipio de Villa de Tezontepec, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N81/N81.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N81/JAN81.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N81/APN81.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N81/FAN81.pdf`,
                    },
                ],
            },
            //Licitación N80
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N80-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico carretera Los Conos - Barrio San Juan en la localidad de Tlaxocoyucan, municipio de Huasca de Ocampo; ubicada en la localidad de Tlaxocoyucan, Municipio de Huasca de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N80/N80.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N80/JAN80.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N80/APN80.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N80/FAN80.pdf`,
                    },
                ],
            },
            //Licitación N79
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N79-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del Tramo: E.C. Huautla-Chalingo-Tzacuala-Tohuaco I, del km 0+000 al km. 5+500 en el municipio de Huautla; ubicada en la localidad de Tohuaco I, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N79/N79.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N79/JAN79.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}18/N79/AMDJAN79.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N79/APN79.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N79/FAN79.pdf`,
                    },
                ],
            },
            //Licitación N78
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N78-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 7 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica El Paredón, localidad Eloxochitlán; ubicada en la localidad y Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N78/N78.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N78/JAN78.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N78/APN78.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N78/FAN78.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}18/N78/AMDFAN78.pdf`,
                    },
                ],
            },
            //Licitación N77
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N77-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica Tecomate; ubicada en la localidad y Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N77/N77.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N77/JAN77.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N77/APN77.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N77/FAN77.pdf`,
                    },
                ],
            },
            //Licitación N76
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N76-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del acceso a Xilico, del km 0+000 al km 2+640; en el municipio de Xochiatipan, ubicada en la localidad de Xilico, Municipio de Xochiatipan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N76/N76.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N76/JAN76.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N76/APN76.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N76/FAN76.pdf`,
                    },
                ],
            },
            //Licitación N75
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N75-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Rehabilitación del tramo: Huitzotlaco-Ecuatitla, del km 0+000 al km 7+500, ubicada en la localidad de Huitzotlaco, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N75/N75.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N75/JAN75.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N75/APN75.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N75/FAN75.pdf`,
                    },
                ],
            },
            //Licitación N74
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N74-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica acceso a la localidad de Tlatzonco; ubicada en la localidad de Tlatzonco, Municipio de Huazalingo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N74/N74.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N74/JAN74.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N74/APN74.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N74/FAN74.pdf`,
                    },
                ],
            },
            //Licitación N73
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N73-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Pavimentación con concreto hidráulico de calle No me Olvides, entre calle Crisantemo y calle Gladiola en la localidad de Xochihuacán, municipio de Epazoyucan; ubicada en la localidad de Xochihuacán, Municipio de Epazoyucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N73/N73.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N73/JAN73.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N73/APN73.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N73/FAN73.pdf`,
                    },
                ],
            },
            //Licitación N72
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N72-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Pavimentación de vialidad en calle Epitacio Mendoza del 0+000 al 0+761 en el municipio de Tolcayuca; ubicada en la localidad y Municipio de Tolcayuca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N72/N72.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N72/JAN72.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N72/APN72.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N72/FAN72.pdf`,
                    },
                ],
            },
            //Licitación N71
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N71-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en Barrio Centro, localidad de Gilo; ubicada en la localidad de San Pedro Gilo (Gilo), Municipio de Eloxochitlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N71/N71.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N71/JAN71.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N71/APN71.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N71/FAN71.pdf`,
                    },
                ],
            },
            //Licitación N70
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N70-2023.',
                'vigencia': 'Vigencia de venta de bases: del 31 de julio al 4 de agosto.',
                'descripcionProcedimiento': 'Reconstrucción de calle Santa Paola entre avenida San Judas Tadeo y calle San Manuel, fraccionamiento Carboneras, en el municipio de Mineral de la Reforma; ubicada en la localidad de Carboneras, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}18/N70/N70.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}18/N70/JAN70.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}18/N70/APN70.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}18/N70/FAN70.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 017/2023',
        'idConvocatoria': 'Convocatoria17',
        'procedimientos': [
            //Licitación N69
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N69-2023.',
                'vigencia': 'Vigencia de venta de bases: del 24 al 31 de julio.',
                'descripcionProcedimiento': 'Modernización de instalaciones de la Feria San Francisco Primera Etapa; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}17/N69/N69.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}17/N69/JAN69.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}17/N69/APN69.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}17/N69/FAN69.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 016/2023',
        'idConvocatoria': 'Convocatoria16',
        'procedimientos': [
            //Licitación N68
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N68-2023.',
                'vigencia': 'Vigencia de venta de bases: del 24 al 28 de julio.',
                'descripcionProcedimiento': 'Laboratorio de Control de Calidad y Análisis de Materiales; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}16/N68/N68.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}16/N68/JAN68.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}16/N68/APN68.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}16/N68/FAN68.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 015/2023',
        'idConvocatoria': 'Convocatoria15',
        'procedimientos': [
            //Licitación N67
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N67-2023.',
                'vigencia': 'Vigencia de venta de bases: del 24 al 28 de julio.',
                'descripcionProcedimiento': 'Rehabilitación Cancha de Futbol Soccer Cedar, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}15/N67/N67.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}15/N67/JAN67.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}15/N67/APN67.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}15/N67/FAN67.pdf`,
                    },
                ],
            },
            //Licitación N66
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N66-2023.',
                'vigencia': 'Vigencia de venta de bases: del 24 al 28 de julio.',
                'descripcionProcedimiento': 'Rehabilitación Cancha de Futbol Soccer Aeropuerto, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}15/N66/N66.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}15/N66/JAN66.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}15/N66/APN66.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}15/N66/FAN66.pdf`,
                    },
                ],
            },
            //Licitación N65
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N65-2023.',
                'vigencia': 'Vigencia de venta de bases: del 24 al 28 de julio.',
                'descripcionProcedimiento': 'Rehabilitación Estadio Revolución; en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}15/N65/N65.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}15/N65/JAN65.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}15/N65/APN65.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}15/N65/FAN65.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 014/2023',
        'idConvocatoria': 'Convocatoria14',
        'procedimientos': [
            //Licitación N64
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N64-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 24 de julio.',
                'descripcionProcedimiento': 'Corredor Seguro de la Red Integrada de Transporte del Corredor Uno de la Zona Metropolitana de Pachuca; de Cobertura Estatal.',
                'urlAnexos': `${ligabase}14/N64/N64.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}14/N64/JAN64.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}14/N64/APN64.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}14/N64/FAN64.pdf`,
                    },
                ],
            },
            //Licitación N63
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N63-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 24 de julio.',
                'descripcionProcedimiento': 'Modificación del inmueble ubicado en calle 16 de Enero de 1869, colonia Periodistas, en Pachuca de Soto Hidalgo, para ser la nueva sede de la Secretaría de Movilidad y Transporte, consistente en la adecuación de accesos y habilitación de oficinas; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}14/N63/N63.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}14/N63/JAN63.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}14/N63/APN63.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}14/N63/FAN63.pdf`,
                    },
                ],
            },
            //Licitación N62
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N62-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 24 de julio.',
                'descripcionProcedimiento': 'Remodelación del inmueble ubicado en carretera Pachuca-Actopan sin número, colonia San Juan Tilcuautla, San Agustín Tlaxiaca, Hidalgo, para el mantenimiento integral complementario en la Ex Hacienda de La Concepción consistente en fachadas interiores y exteriores, impermeabilización de lozas y rehabilitación de cocina; ubicada en la localidad de La Concepción, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}14/N62/N62.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}14/N62/JAN62.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}14/N62/APN62.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}14/N62/FAN62.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 013/2023',
        'idConvocatoria': 'Convocatoria13',
        'procedimientos': [
            //Licitación N61
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N61-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Construcción de huellas de concreto hidráulico y empedrado en la localidad de San Nicolás; ubicada en la localidad de San Nicolás, Municipio de Jacala de Ledezma, Estado de Hidalgo. Segundo Procedimiento.',
                'urlAnexos': `${ligabase}13/N61/N61.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}13/N61/JAN61.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}13/N61/APN61.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}13/N61/FAN61.pdf`,
                    },
                ],
            },
            //Licitación N60
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N60-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Construcción de pavimento de Calle 16 de Enero, Col. El Calvario, municipio de Tepeapulco; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo. Segundo Procedimiento',
                'urlAnexos': `${ligabase}13/N60/N60.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}13/N60/JAN60.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}13/N60/APN60.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}13/N60/FAN60.pdf`,
                    },
                ],
            },
            //Licitación N59
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N59-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Rehabilitación del Boulevard paso por Actopan, en el municipio de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo. Segundo Procedimiento',
                'urlAnexos': `${ligabase}13/N59/N59.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}13/N59/JAN59.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}13/N59/APN59.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}13/N59/FAN59.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 012/2023',
        'idConvocatoria': 'Convocatoria12',
        'procedimientos': [
            //Licitación N58
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N58-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Pavimentación en concreto hidráulico, alumbrado público, guarniciones y banquetas, en el acceso a Ocote Chico; ubicada en la localidad de El Ocote Chico, Municipio de Epazoyucan, Estado de Hidalgo. Segundo procedimiento.',
                'urlAnexos': `${ligabase}12/N58/N58.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}12/N58/JAN58.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}12/N58/APN58.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}12/N58/FAN58.pdf`,
                    },
                ],
            },
            //Licitación N57
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N57-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Construcción de andador de concreto hidráulico en localidad El Sabino, calle Camino Real; ubicada en la localidad de Jacala, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}12/N57/N57.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}12/N57/JAN57.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}12/N57/AMDJAN57.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}12/N57/APN57.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}12/N57/FAN57.pdf`,
                    },
                ],
            },
            //Licitación N56
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N56-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Modernización del camino rural Xuchitlan - Toscalao, subtramo: Toscalao - Tetlapaya; ubicada en la localidad de Xuchitlán, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}12/N56/N56.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}12/N56/JAN56.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}12/N56/APN56.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}12/N56/FAN56.pdf`,
                    },
                ],
            },
            //Licitación N55
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N55-2023.',
                'vigencia': 'Vigencia de venta de bases: del 17 al 21 de julio.',
                'descripcionProcedimiento': 'Construcción del colector pluvial circuito Nuevo Pachuca, Col. Juan C. Doria; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo. Segundo procedimiento',
                'urlAnexos': `${ligabase}12/N55/N55.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}12/N55/JAN55.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}12/N55/APN55.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}12/N55/FAN55.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 011/2023',
        'idConvocatoria': 'Convocatoria11',
        'procedimientos': [
            //Licitación N54
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N54-2023.',
                'vigencia': 'Vigencia de venta de bases: del 10 al 14 de julio.',
                'descripcionProcedimiento': 'Desarrollo del proyecto ejecutivo arquitectónico para la remodelación del Parque David Ben Gurión, que proyecte la creación de espacios recreativos, culturales y de integración familiar en la ciudad de Pachuca de soto, Hidalgo;  ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}11/N54/N54.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}11/N54/JAN54.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}11/N54/APN54.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}11/N54/FAN54.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 010/2023',
        'idConvocatoria': 'Convocatoria10',
        'procedimientos': [
            //Licitación N53
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N53-2023.',
                'vigencia': 'Vigencia: del 19 al 26 de junio.',
                'descripcionProcedimiento': 'Rehabilitación de pavimento asfáltico, Av. Universidad - Entronque Blvd. Colosio; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}10/N53/N53.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}10/N53/JAN53.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}10/N53/APN53.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}10/N53/FAN53.pdf`,
                    },
                ],
            },
            //Licitación N52
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N52-2023.',
                'vigencia': 'Vigencia: del 19 al 26 de junio.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de calle Insurgentes Oriente - Niños Héroes Sur, municipio de Tlanalapa; ubicada en la localidad y Municipio de Tlanalapa, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}10/N52/N52.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}10/N52/JAN52.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}10/N52/APN52.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}10/N52/FAN52.pdf`,
                    },
                ],
            },
            //Licitación N51
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N51-2023.',
                'vigencia': 'Vigencia: del 19 al 26 de junio.',
                'descripcionProcedimiento': 'Rehabilitación del sistema red general de agua potable en la cabecera municipal de Emiliano Zapata; ubicada en la localidad y Municipio de Emiliano Zapata, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}10/N51/N51.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}10/N51/JAN51.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}10/N51/APN51.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}10/N51/FAN51.pdf`,
                    },
                ],
            },
            //Licitación N50
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N50-2023.',
                'vigencia': 'Vigencia: del 19 al 26 de junio.',
                'descripcionProcedimiento': 'Pavimentación de Av. Amaque, localidad Amaque, Mineral de la Reforma; ubicada en la localidad de Amaque, Municipio de Mineral de la Reforma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}10/N50/N50.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}10/N50/JAN50.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}10/N50/APN50.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}10/N50/FAN50.pdf`,
                    },
                ],
            },
            //Licitación N49
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N49-2023.',
                'vigencia': 'Vigencia: del 19 al 26 de junio.',
                'descripcionProcedimiento': 'Rehabilitación de pavimento asfáltico, Boulevard Nuevo Hidalgo tramo Blvd. Rojo Gómez - Blvd. Colosio; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}10/N49/N49.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}10/N49/JAN49.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}10/N49/FAN49.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}10/N49/FAN49.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 09/2023',
        'idConvocatoria': 'Convocatoria9',
        'procedimientos': [
            //Licitación N48
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N48-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Retiro, suministro, instalación y puesta en marcha de elevadores de pasajeros, 6 paradas, con capacidad máxima de 1000 kilogramos cada uno, para el inmueble que ocupa el Palacio de Gobierno de la Ciudad de Pachuca de Soto, Hidalgo. Incluye adquisición y sustitución de puertas, botoneras, cabinas de acero inoxidable, maquinaria y sistema de desplazamiento en medidas adecuadas a los cubos existentes al interior del inmueble; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}9/N48/N48.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}9/N48/JAN48.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}9/N48/APN48.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}9/N48/FAN48.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 08/2023',
        'idConvocatoria': 'Convocatoria8',
        'procedimientos': [
            //Licitación N47
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N47-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Construcción de sistema de agua potable de Salinas, municipio de El Cardonal; ubicada en Varias localidades del Municipio de Cardonal, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N47/N47.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N47/JAN47.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N47/APN47.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N47/FAN47.pdf`,
                    },
                ],
            },
            //Licitación N46
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N46-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en calles de la localidad de El Oro, municipio de Ixmiquilpan; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N46/N46.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N46/JAN46.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N46/APN46.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N46/FAN46.pdf`,
                    },
                ],
            },
            //Licitación N45
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N45-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Construcción de pavimentación asfáltica de varias calles de la cabecera municipal, municipio de Chilcuautla; ubicada en la localidad y Municipio de Chilcuautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N45/N45.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N45/JAN45.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N45/APN45.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N45/FAN45.pdf`,
                    },
                ],
            },
            //Licitación N44
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N44-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Construcción de huellas de concreto hidráulico y empedrado en la localidad de San Nicolás; ubicada en la localidad de San Nicolás, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N44/N44.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N44/JAN44.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N44/APN44.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N44/FAN44.pdf`,
                    },
                ],
            },
            //Licitación N43
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N43-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Modernización del camino Jacala - Quetzalapa en el municipio de Jacala; ubicada en la localidad de Octupilla, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N43/N43.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N43/JAN43.pdf`,
                    },
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N43/FAN43.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N43/FAN43.pdf`,
                    },
                ],
            },
            //Licitación N42
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N42-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico de calle Nicolás Bravo primera etapa en colonia Loma Bonita; ubicada en la localidad de Zacualtipán, Municipio de Zacualtipán de Ángeles, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N42/N42.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N42/JAN42.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N42/APN42.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}8/N42/AMDAPN42.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N42/FAN42.pdf`,
                    },
                ],
            },
            //Licitación N41
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N41-2023.',
                'vigencia': 'Vigencia: del 12 al 19 de junio.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del acceso a la Unidad Deportiva de Doxhey; ubicada en la localidad de Doxey, Municipio de Tlaxcoapan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N41/N41.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N41/JAN41.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N41/APN41.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N41/FAN41.pdf`,
                    },
                ],
            },
            //Licitación N40
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N40-2023.',
                'vigencia': 'Vigencia: del 12 al 16 de junio.',
                'descripcionProcedimiento': 'Construcción de pavimento de Calle 16 de Enero, Col. El Calvario, municipio de Tepeapulco; ubicada en la localidad y Municipio de Tepeapulco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N40/N40.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N40/JAN40.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N40/APN40.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N40/FAN40.pdf`,
                    },
                ],
            },
            //Licitación N39
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N39-2023.',
                'vigencia': 'Vigencia: del 12 al 16 de junio.',
                'descripcionProcedimiento': 'Rehabilitación del Boulevard paso por Actopan, en el municipio de Actopan; ubicada en la localidad y Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N39/N39.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N39/JAN39.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N39/APN39.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N39/FAN39.pdf`,
                    },
                ],
            },
            //Licitación N38
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N38-2023.',
                'vigencia': 'Vigencia: del 12 al 16 de junio.',
                'descripcionProcedimiento': 'Construcción de pavimento hidráulico en salida principal Avenida Juárez; ubicada en la localidad y Municipio de Atotonilco el Grande, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N38/N38.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N38/JAN38.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N38/APN38.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N38/FAN38.pdf`,
                    },
                ],
            },
            //Licitación N37
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N37-2023.',
                'vigencia': 'Vigencia: del 12 al 16 de junio.',
                'descripcionProcedimiento': 'Pavimento estampado y banquetas en calle Benito Juárez en la localidad de Chicavasco, Actopan; ubicada en la localidad de Chicavasco, Municipio de Actopan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}8/N37/N37.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}8/N37/JAN37.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}8/N37/APN37.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}8/N37/FAN37.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 07/2023',
        'idConvocatoria': 'Convocatoria7',
        'procedimientos': [
            //Licitación N36
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N36-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 7 de junio.',
                'descripcionProcedimiento': 'Mejoramiento del camino entronque carretero (Pachuca - Huejutla) - Tlalnepanco, municipio de Huejutla de Reyes; ubicada en la localidad de Tlalnepanco, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N36/N36.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N36/JAN36.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N36/APN36.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N36/FAN36.pdf`,
                    },
                ],
            },
            //Licitación N35
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N35-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 7 de junio.',
                'descripcionProcedimiento': 'Mejoramiento de camino Huehutla - Tilcalco - Las Nueces, municipio de Huejutla de Reyes; ubicada en la localidad de Tilcalco, Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N35/N35.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N35/JAN35.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N35/APN35.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N35/FAN35.pdf`,
                    },
                ],
            },
            //Licitación N34
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N34-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 7 de junio.',
                'descripcionProcedimiento': 'Modernización y ampliación de camino rural E.C. Huejutla - San Felipe Orizatlán, E.C. Pahuayo, en la localidad de Tzinancatitla; ubicada en la localidad de Tzinancatitla, Municipio de Jaltocán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N34/N34.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N34/JAN34.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N34/APN34.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N34/FAN34.pdf`,
                    },
                ],
            },
            //Licitación N33
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N33-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 7 de junio.',
                'descripcionProcedimiento': 'Construcción de tanque de agua potable en San Agustín Metzquititlán; ubicada en la localidad de Tuzanapa, Municipio de San Agustín Metzquititlán, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N33/N33.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N33/JAN33.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N33/APN33.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N33/FAN33.pdf`,
                    },
                ],
            },
            //Licitación N32
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N32-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 6 de junio.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de acceso a panteón de Doxey, municipio de Tlaxcoapan; ubicada en la localidad de Doxey, Municipio de Tlaxcoapan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N32/N32.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N32/JAN32.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N32/APN32.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N32/FAN32.pdf`,
                    },
                ],
            },
            //Licitación N31
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N31-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 6 de junio.',
                'descripcionProcedimiento': 'Rehabilitación del dren pluvial Las Torres; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N31/N31.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N31/JAN31.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N31/APN31.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N31/FAN31.pdf`,
                    },
                ],
            },
            //Licitación N30
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N30-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 6 de junio.',
                'descripcionProcedimiento': 'Construcción del colector pluvial circuito Nuevo Pachuca, Col. Juan C. Doria; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}7/N30/N30.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}7/N30/JAN30.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}7/N30/APN30.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}7/N30/FAN30.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 06/2023',
        'idConvocatoria': 'Convocatoria6',
        'procedimientos': [
            //Licitación N29
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N29-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Reconstrucción de la carretera estatal Apan - La Unión; ubicada en la localidad y Municipio de Apan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N29/N29.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N29/JAN29.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N29/APN29.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N29/FAN29.pdf`,
                    },
                ],
            },
            //Licitación N28
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N28-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en acceso principal en la localidad de El Manantial; ubicada en la localidad de El Manantial, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N28/N28.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N28/JAN28.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N28/APN28.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N28/FAN28.pdf`,
                    },
                ],
            },
            //Licitación N27
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N27-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del libramiento Atitalaquia - Tlaxcoapan, municipio de Atitalaquia; ubicada en la localidad de Tlalminulpa, Municipio de Atitalaquia, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N27/N27.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N27/JAN27.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N27/APN27.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N27/FAN27.pdf`,
                    },
                ],
            },
            //Licitación N26
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N26-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Construcción del dren pluvial Nopancalco - Tezontle; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N26/N26.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N26/JAN26.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N26/APN26.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N26/FAN26.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}6/N26/AMDFAN26.pdf`,
                    },
                ],
            },
            //Licitación N25
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N25-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Rehabilitación de pavimento asfáltico, Antigua Carretera México - Pachuca, colonia Santa Julia; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N25/N25.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N25/JAN25.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N25/APN25.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N25/FAN25.pdf`,
                    },
                ],
            },
            //Licitación N24
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N24-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Pavimentación en concreto hidráulico, alumbrado público, guarniciones y banquetas, en el acceso a Ocote Chico; ubicada en la localidad de El Ocote Chico, Municipio de Epazoyucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N24/N24.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N24/JAN24.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N24/APN24.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N24/FAN24.pdf`,
                    },
                ],
            },
            //Licitación N23
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N23-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Rehabilitación de guarniciones y banquetas en Ferrería en calle principal, Metepec; ubicada en la localidad de Ferrería de Apulco, Municipio de Metepec, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N23/N23.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N23/JAN23.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N23/APN23.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N23/FAN23.pdf`,
                    },
                ],
            },
            //Licitación N22
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N22-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 5 de junio.',
                'descripcionProcedimiento': 'Rehabilitación de guarniciones y banquetas en Estación de Apulco tramo: acceso Estación de Apulco - CBTA 126, municipio de Metepec; ubicada en la localidad de Estación de Apulco, Municipio de Metepec, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}6/N22/N22.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}6/N22/JAN22.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}6/N22/APN22.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}6/N22/FAN22.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 05/2023',
        'idConvocatoria': 'Convocatoria5',
        'procedimientos': [
            //Licitación N21
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N21-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 2 de junio.',
                'descripcionProcedimiento': 'Reconstrucción de pavimentación asfáltica en avenida Emilio Carranza, Sector Huizache, San Agustín Tlaxiaca; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}5/N21/N21.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}5/N21/JAN21.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}5/N21/APN21.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}5/N21/FAN21.pdf`,
                    },
                ],
            },
            //Licitación N20
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N20-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 2 de junio.',
                'descripcionProcedimiento': 'Reconstrucción de la C.E. Ramal - Tianguistengo (Acceso a Tianguistengo); ubicada en la localidad y Municipio de Tianguistengo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}5/N20/N20.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}5/N20/JAN20.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}5/N20/APN20.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}5/N20/FAN20.pdf`,
                    },
                ],
            },
            //Licitación N19
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N19-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 2 de junio.',
                'descripcionProcedimiento': 'Construcción de pavimento de concreto hidráulico de Barrio Hondo a la localidad de Pahuatitla; ubicada en la localidad de Pahuatitla, Municipio de Huautla, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}5/N19/N19.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}5/N19/JAN19.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}5/N19/APN19.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}5/N19/FAN19.pdf`,
                    },
                ],
            },
            //Licitación N18
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N18-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 2 de junio.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del Libramiento Oriente - La Loma de La Cruz - Universidad, municipio de Ixmiquilpan; ubicada en la localidad de La Loma de la Cruz, Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}5/N18/N18.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}5/N18/JAN18.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}5/N18/APN18.pdf`,
                    },
                    {
                        'resultado': 'Anexo modificatorio',
                        'urlresultado': `${ligabase}5/N18/AMDAPN18.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}5/N18/FAN18.pdf`,
                    },
                ],
            },
            //Licitación N17
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N17-2023.',
                'vigencia': 'Vigencia: del 29 de mayo al 2 de junio.',
                'descripcionProcedimiento': 'Reconstrucción de carpeta asfáltica de la C.E. Ajacuba - San Juan Tepa, municipio de Ajacuba; ubicada en la localidad de San Nicolás Tecomatlán, Municipio de Ajacuba, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}5/N17/N17.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}5/N17/JAN17.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}5/N17/APN17.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}5/N17/FAN17.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 04/2023',
        'idConvocatoria': 'Convocatoria4',
        'procedimientos': [
            //Licitación N16
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N16-2023.',
                'vigencia': 'Vigencia: del 22 al 29 de mayo.',
                'descripcionProcedimiento': 'Rehabilitación de pavimentación asfáltica de la avenida Vicente Guerrero en 1A. Demarcación Poniente, Mixquiahuala de Juárez; ubicada en la localidad y Municipio de Mixquiahuala de Juárez, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N16/N16.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N16/JAN16.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N16/APN16.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N16/FAN16.pdf`,
                    },
                ],
            },
            //Licitación N15
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N15-2023.',
                'vigencia': 'Vigencia: del 22 al 29 de mayo.',
                'descripcionProcedimiento': 'Pavimentación asfáltica del circuito Los Reyes, municipio de Cardonal; ubicada en la localidad de Los Reyes, Municipio de Cardonal, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N15/N15.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N15/JAN15.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N15/APN15.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N15/FAN15.pdf`,
                    },
                ],
            },
            //Licitación N14
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N14-2023.',
                'vigencia': 'Vigencia: del 22 al 29 de mayo.',
                'descripcionProcedimiento': 'Pavimentación hidráulica en acceso principal Boxaxni - Santa Mónica El Sitio, municipio Santiago de Anaya; ubicada en la localidad de El Sitio, Municipio de Santiago de Anaya, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N14/N14.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N14/JAN14.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N14/APN14.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N14/FAN14.pdf`,
                    },
                ],
            },
            //Licitación N13
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N13-2023.',
                'vigencia': 'Vigencia: del 22 al 29 de mayo.',
                'descripcionProcedimiento': 'Construcción de pavimentación hidráulica en calle Las Torres, municipio de Tetepango; ubicada en la localidad y Municipio de Tetepango, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N13/N13.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N13/JAN13.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N13/APN13.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N13/FAN13.pdf`,
                    },
                ],
            },
            //Licitación N12
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N12-2023.',
                'vigencia': 'Vigencia: del 22 al 29 de mayo.',
                'descripcionProcedimiento': 'Reconstrucción de la carretera estatal acceso a Tepeji del Río, municipio de Tepeji del Río; ubicada en la localidad y Municipio de Tepeji del Río de Ocampo, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N12/N12.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N12/JAN12.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N12/APN12.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N12/FAN12.pdf`,
                    },
                ],
            },
            //Licitación N11
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N11-2023.',
                'vigencia': 'Vigencia: del 22 al 26 de mayo.',
                'descripcionProcedimiento': 'Construcción de empedrado ahogado en concreto hidráulico calle Luis Donaldo Colosio, municipio Mineral del Chico; ubicada en la localidad y Municipio de Mineral del Chico, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N11/N11.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N11/JAN11.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N11/APN11.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N11/FAN11.pdf`,
                    },
                ],
            },
            //Licitación N10
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N10-2023.',
                'vigencia': 'Vigencia: del 22 al 26 de mayo.',
                'descripcionProcedimiento': 'Pavimentación asfáltica de camino El Madho, municipio de Alfajayucan; ubicada en la localidad de Madho Corrales, Municipio de Alfajayucan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N10/N10.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N10/JAN10.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N10/APN10.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N10/FAN10.pdf`,
                    },
                ],
            },
            //Licitación N9
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N9-2023.',
                'vigencia': 'Vigencia: del 22 al 26 de mayo.',
                'descripcionProcedimiento': 'Reconstrucción de pavimentación asfáltica en camino Benito Juárez – Llano Largo, municipio de San Agustín Tlaxiaca; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N9/N9.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N9/JAN9.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N9/APN9.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N9/FAN9.pdf`,
                    },


                ],
            },
            //Licitación N8
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N8-2023.',
                'vigencia': 'Vigencia: del 22 al 26 de mayo.',
                'descripcionProcedimiento': 'Construcción de huellas de concreto hidráulico y empedrado en la localidad de Agua Fría Chica; ubicada en la localidad de Agua Fría Chica, Municipio de Jacala de Ledezma, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N8/N8.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N8/JAN8.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N8/APN8.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N8/FAN8.pdf`,
                    },
                ],
            },
            //Licitación N7
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N7-2023.',
                'vigencia': 'Vigencia: del 22 al 26 de mayo.',
                'descripcionProcedimiento': 'Modernización y ampliación del camino (Atlapexco-Calnali) – Tlachapa -  Atlajco – Cochotla, municipio de Atlapexco; ubicada en la localidad de Cochotla, Municipio de Atlapexco, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N7/N7.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N7/JAN7.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N7/APN7.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N7/FAN7.pdf`,
                    },
                ],
            },
            //Licitación N6
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N6-2023.',
                'vigencia': 'Vigencia: del 22 al 26 de mayo.',
                'descripcionProcedimiento': 'Rehabilitación de pavimento asfáltico en avenida Felipe Ángeles, colonia Centro, municipio de Ixmiquilpan; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}4/N6/N6.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}4/N6/JAN6.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}4/N6/APN6.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}4/N6/FAN6.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 03/2023',
        'idConvocatoria': 'Convocatoria3',
        'procedimientos': [
            //Licitación N5
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N5-2023.',
                'vigencia': 'Vigencia: del 15 al 19 de mayo.',
                'descripcionProcedimiento': 'Rehabilitación de Centro Gerontológico Integral de Huejutla de Reyes; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}3/N5/N5.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}3/N5/JAN5.pdf`,
                    },
                ],
            },
            //Licitación N4
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N4-2023.',
                'vigencia': 'Vigencia: del 15 al 19 de mayo.',
                'descripcionProcedimiento': 'Pavimentación de concreto hidráulico San Pedro Huilxoltitla hacia Llano Grande, municipio Mineral del Monte; ubicada en la localidad de San Pedro Huixotitla, Municipio de Mineral del Monte, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}3/N4/N4.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}3/N4/JAN4.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}3/N4/APN4.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}3/N4/FAN4.pdf`,
                    },
                ],
            },
            //Licitación N3
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N3-2023.',
                'vigencia': 'Vigencia: del 15 al 19 de mayo.',
                'descripcionProcedimiento': 'Rehabilitación camino rural Tilcuautla - entronque carretero Benito Juárez San José Capulines, municipio de San Agustín Tlaxiaca; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}3/N3/N3.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}3/N3/JAN3.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}3/N3/APN3.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}3/N3/FAN3.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 02/2023',
        'idConvocatoria': 'Convocatoria2',
        'procedimientos': [
            //Licitación N2
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N2-2023.',
                'vigencia': 'Vigencia: del 8 al 12 de mayo.',
                'descripcionProcedimiento': 'Construcción de andador en San Salvador en la localidad Caxuxi, camino Caxuxi - San Salvador;  ubicada en la localidad de Caxuxi, Municipio de San Salvador, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}2/N2/N2.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}2/N2/JAN2.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}2/N2/APN2.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}2/N2/FAN2.pdf`,
                    },
                ],
            },
        ],
    },
    {
        'numConvocatoria': 'Convocatoria No. 01/2023',
        'idConvocatoria': 'Convocatoria1',
        'procedimientos': [
            //Licitación N1
            {
                'numProcedimiento': 'Licitación Pública No. EO-SIPDUS-N1-2023.',
                'vigencia': 'Vigencia: del 1 al 8 de mayo.',
                'descripcionProcedimiento': 'Dictaminación y proyectos complementarios de la obra sustitución y ampliación del Hospital General de Pachuca;  ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                'urlAnexos': `${ligabase}1/N1/N1.rar`,
                'resultados': [
                    {
                        'resultado': 'Aclaraciones',
                        'urlresultado': `${ligabase}1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado': 'Apertura',
                        'urlresultado': `${ligabase}1/N1/APN1.pdf`,
                    },
                    {
                        'resultado': 'Fallo',
                        'urlresultado': `${ligabase}1/N1/FAN1.pdf`,
                    },
                ],
            },
        ],
    },
]